(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
"use strict";

/*!
  * Bootstrap v5.3.7 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $46009cb9c7837d26$export$71511d61b312f219(o) {
    $46009cb9c7837d26$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $46009cb9c7837d26$export$71511d61b312f219(o);
}


function $86e094c5da0c577e$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($86e094c5da0c577e$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $051e0db87d749224$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $cf9fea04db19f9e8$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $cd0610f01f5fdff1$export$71511d61b312f219(self, call) {
    if (call && ((0, $cf9fea04db19f9e8$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $051e0db87d749224$export$71511d61b312f219)(self);
}


function $6e26aa1d62930328$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $46009cb9c7837d26$export$71511d61b312f219)(derived);
    return (0, $cd0610f01f5fdff1$export$71511d61b312f219)(_this, (0, $86e094c5da0c577e$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $46009cb9c7837d26$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $bc9781ba3abb1241$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $748a7371a616f526$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $748a7371a616f526$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $748a7371a616f526$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $748a7371a616f526$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $73942673364072c5$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $e30910f7ba0570c5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $46009cb9c7837d26$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $4c25d76cb59647ad$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $4c25d76cb59647ad$export$71511d61b312f219 = Reflect.get;
    else $4c25d76cb59647ad$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $e30910f7ba0570c5$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $4c25d76cb59647ad$export$71511d61b312f219(target, property, receiver || target);
}



function $8893fc44be977511$export$71511d61b312f219(o, p) {
    $8893fc44be977511$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8893fc44be977511$export$71511d61b312f219(o, p);
}


function $88a32c98e8928a08$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $8893fc44be977511$export$71511d61b312f219)(subClass, superClass);
}



function $532b8962aa050863$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $73942673364072c5$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $b6ff0fef1635ca17$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b6ff0fef1635ca17$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $b6ff0fef1635ca17$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $c2d364e4a461e6dc$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ea164edd89d9d50$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $cd96dc2340e92ae4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $fcba485caa39515b$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $ae489d8791914134$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $fcba485caa39515b$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $fcba485caa39515b$export$71511d61b312f219)(o, minLen);
}


function $b96fd51f6bb7957d$export$71511d61b312f219(arr, i) {
    return (0, $c2d364e4a461e6dc$export$71511d61b312f219)(arr) || (0, $8ea164edd89d9d50$export$71511d61b312f219)(arr, i) || (0, $ae489d8791914134$export$71511d61b312f219)(arr, i) || (0, $cd96dc2340e92ae4$export$71511d61b312f219)();
}



function $e32dd7a81f75152e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $fcba485caa39515b$export$71511d61b312f219)(arr);
}


function $ed40bf1a6dc7f0dc$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $778f42f3fc972237$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $cd50c780af06a876$export$71511d61b312f219(arr) {
    return (0, $e32dd7a81f75152e$export$71511d61b312f219)(arr) || (0, $ed40bf1a6dc7f0dc$export$71511d61b312f219)(arr) || (0, $ae489d8791914134$export$71511d61b312f219)(arr) || (0, $778f42f3fc972237$export$71511d61b312f219)();
}



var $a66e6eefcf9d6c2e$exports = {};

$parcel$export($a66e6eefcf9d6c2e$exports, "popperGenerator", function () { return $10838678ae23ed64$export$ed5e13716264f202; });
$parcel$export($a66e6eefcf9d6c2e$exports, "detectOverflow", function () { return $6cb24906b58baccb$export$2e2bcd8739ae039; });
$parcel$export($a66e6eefcf9d6c2e$exports, "createPopperBase", function () { return $10838678ae23ed64$export$8f7491d57c8f97a9; });
$parcel$export($a66e6eefcf9d6c2e$exports, "createPopper", function () { return $207128722dcd8d42$export$8f7491d57c8f97a9; });
$parcel$export($a66e6eefcf9d6c2e$exports, "createPopperLite", function () { return $f45435ef08e25574$export$8f7491d57c8f97a9; });
var $7d6bc8e9bbf80a4b$exports = {};

$parcel$export($7d6bc8e9bbf80a4b$exports, "top", function () { return $7d6bc8e9bbf80a4b$export$1e95b668f3b82d; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "bottom", function () { return $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "right", function () { return $7d6bc8e9bbf80a4b$export$79ffe56a765070d2; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "left", function () { return $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "auto", function () { return $7d6bc8e9bbf80a4b$export$dfb5619354ba860; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "basePlacements", function () { return $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "start", function () { return $7d6bc8e9bbf80a4b$export$b3571188c770cc5a; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "end", function () { return $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "clippingParents", function () { return $7d6bc8e9bbf80a4b$export$390fd549c5303b4d; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "viewport", function () { return $7d6bc8e9bbf80a4b$export$d7b7311ec04a3e8f; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "popper", function () { return $7d6bc8e9bbf80a4b$export$ae5ab1c730825774; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "reference", function () { return $7d6bc8e9bbf80a4b$export$ca50aac9f3ba507f; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "variationPlacements", function () { return $7d6bc8e9bbf80a4b$export$368f9a87e87fa4e1; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "placements", function () { return $7d6bc8e9bbf80a4b$export$803cd8101b6c182b; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "beforeRead", function () { return $7d6bc8e9bbf80a4b$export$421679a7c3d56e; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "read", function () { return $7d6bc8e9bbf80a4b$export$aafa59e2e03f2942; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "afterRead", function () { return $7d6bc8e9bbf80a4b$export$6964f6c886723980; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "beforeMain", function () { return $7d6bc8e9bbf80a4b$export$c65e99957a05207c; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "main", function () { return $7d6bc8e9bbf80a4b$export$f22da7240b7add18; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "afterMain", function () { return $7d6bc8e9bbf80a4b$export$bab79516f2d662fe; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "beforeWrite", function () { return $7d6bc8e9bbf80a4b$export$8d4d2d70e7d46032; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "write", function () { return $7d6bc8e9bbf80a4b$export$68d8715fc104d294; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "afterWrite", function () { return $7d6bc8e9bbf80a4b$export$70a6e5159acce2e6; });
$parcel$export($7d6bc8e9bbf80a4b$exports, "modifierPhases", function () { return $7d6bc8e9bbf80a4b$export$d087d3878fdf71d5; });
var $7d6bc8e9bbf80a4b$export$1e95b668f3b82d = 'top';
var $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb = 'bottom';
var $7d6bc8e9bbf80a4b$export$79ffe56a765070d2 = 'right';
var $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4 = 'left';
var $7d6bc8e9bbf80a4b$export$dfb5619354ba860 = 'auto';
var $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3 = [
    $7d6bc8e9bbf80a4b$export$1e95b668f3b82d,
    $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb,
    $7d6bc8e9bbf80a4b$export$79ffe56a765070d2,
    $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4
];
var $7d6bc8e9bbf80a4b$export$b3571188c770cc5a = 'start';
var $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8 = 'end';
var $7d6bc8e9bbf80a4b$export$390fd549c5303b4d = 'clippingParents';
var $7d6bc8e9bbf80a4b$export$d7b7311ec04a3e8f = 'viewport';
var $7d6bc8e9bbf80a4b$export$ae5ab1c730825774 = 'popper';
var $7d6bc8e9bbf80a4b$export$ca50aac9f3ba507f = 'reference';
var $7d6bc8e9bbf80a4b$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7d6bc8e9bbf80a4b$export$b3571188c770cc5a,
        placement + "-" + $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8
    ]);
}, []);
var $7d6bc8e9bbf80a4b$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3, [
    $7d6bc8e9bbf80a4b$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7d6bc8e9bbf80a4b$export$b3571188c770cc5a,
        placement + "-" + $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7d6bc8e9bbf80a4b$export$421679a7c3d56e = 'beforeRead';
var $7d6bc8e9bbf80a4b$export$aafa59e2e03f2942 = 'read';
var $7d6bc8e9bbf80a4b$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7d6bc8e9bbf80a4b$export$c65e99957a05207c = 'beforeMain';
var $7d6bc8e9bbf80a4b$export$f22da7240b7add18 = 'main';
var $7d6bc8e9bbf80a4b$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7d6bc8e9bbf80a4b$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7d6bc8e9bbf80a4b$export$68d8715fc104d294 = 'write';
var $7d6bc8e9bbf80a4b$export$70a6e5159acce2e6 = 'afterWrite';
var $7d6bc8e9bbf80a4b$export$d087d3878fdf71d5 = [
    $7d6bc8e9bbf80a4b$export$421679a7c3d56e,
    $7d6bc8e9bbf80a4b$export$aafa59e2e03f2942,
    $7d6bc8e9bbf80a4b$export$6964f6c886723980,
    $7d6bc8e9bbf80a4b$export$c65e99957a05207c,
    $7d6bc8e9bbf80a4b$export$f22da7240b7add18,
    $7d6bc8e9bbf80a4b$export$bab79516f2d662fe,
    $7d6bc8e9bbf80a4b$export$8d4d2d70e7d46032,
    $7d6bc8e9bbf80a4b$export$68d8715fc104d294,
    $7d6bc8e9bbf80a4b$export$70a6e5159acce2e6
];


var $920f6fcae42d0d0a$exports = {};

$parcel$export($920f6fcae42d0d0a$exports, "applyStyles", function () { return $712e6ea51e777f86$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "arrow", function () { return $9b11dd5b6cc8a650$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "computeStyles", function () { return $da9e26b819e4ec3c$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "eventListeners", function () { return $be3dff66b8ae1fff$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "flip", function () { return $519bd39db5538ac1$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "hide", function () { return $a0d759f56ba1ef2a$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "offset", function () { return $39bacdf19877ee23$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "popperOffsets", function () { return $e9276f7d9fbf263d$export$2e2bcd8739ae039; });
$parcel$export($920f6fcae42d0d0a$exports, "preventOverflow", function () { return $4ff36eb9022d289d$export$2e2bcd8739ae039; });
function $303702e262a6ec35$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $20233ac2574f9bee$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $7ab7969a804dce04$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $7ab7969a804dce04$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $7ab7969a804dce04$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $712e6ea51e777f86$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element) || !(0, $303702e262a6ec35$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $712e6ea51e777f86$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element) || !(0, $303702e262a6ec35$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $712e6ea51e777f86$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $712e6ea51e777f86$var$applyStyles,
    effect: $712e6ea51e777f86$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $4282b594a1215105$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $785327874c9e8d31$export$8960430cfd85939f = Math.max;
var $785327874c9e8d31$export$96ec731ed4dcb222 = Math.min;
var $785327874c9e8d31$export$2077e0241d6afd3c = Math.round;



function $3aa3ca3e735c1ba3$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $96f81adf64fb639a$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $3aa3ca3e735c1ba3$export$2e2bcd8739ae039)());
}


function $f43312ba6dd4c850$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $785327874c9e8d31$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $785327874c9e8d31$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(element) ? (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $96f81adf64fb639a$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $1db232f53c3f2351$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $6f4bb195b9657bfd$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $7ab7969a804dce04$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $e746ddabd93b9de2$export$2e2bcd8739ae039(element) {
    return (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $3bdf3bed90cc6158$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $303702e262a6ec35$export$2e2bcd8739ae039)(element)) >= 0;
}




function $40da45f1d275600f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9f74b8de57840dbe$export$2e2bcd8739ae039(element) {
    if ((0, $303702e262a6ec35$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $7ab7969a804dce04$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $40da45f1d275600f$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $e181b337d8fb704c$var$getTrueOffsetParent(element) {
    if (!(0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e181b337d8fb704c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $3aa3ca3e735c1ba3$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $3aa3ca3e735c1ba3$export$2e2bcd8739ae039)());
    if (isIE && (0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9f74b8de57840dbe$export$2e2bcd8739ae039)(element);
    if ((0, $7ab7969a804dce04$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $303702e262a6ec35$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e181b337d8fb704c$export$2e2bcd8739ae039(element) {
    var window = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(element);
    var offsetParent = $e181b337d8fb704c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3bdf3bed90cc6158$export$2e2bcd8739ae039)(offsetParent) && (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $e181b337d8fb704c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $303702e262a6ec35$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $303702e262a6ec35$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $e181b337d8fb704c$var$getContainingBlock(element) || window;
}


function $43914a77c2347875$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $cee56874ccbfb6e6$export$f28d906d67a997f3(min, value, max) {
    return (0, $785327874c9e8d31$export$8960430cfd85939f)(min, (0, $785327874c9e8d31$export$96ec731ed4dcb222)(value, max));
}
function $cee56874ccbfb6e6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cee56874ccbfb6e6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $49277832eaf9aa5f$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $d59b22009de7b956$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $49277832eaf9aa5f$export$2e2bcd8739ae039)(), paddingObject);
}


function $57936895c2815dad$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $9b11dd5b6cc8a650$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $d59b22009de7b956$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $57936895c2815dad$export$2e2bcd8739ae039)(padding, (0, $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3)));
};
function $9b11dd5b6cc8a650$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $4282b594a1215105$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $43914a77c2347875$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4),
        (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $9b11dd5b6cc8a650$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $1db232f53c3f2351$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d) : (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb) : (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $e181b337d8fb704c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cee56874ccbfb6e6$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $9b11dd5b6cc8a650$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $6f4bb195b9657bfd$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $9b11dd5b6cc8a650$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $9b11dd5b6cc8a650$var$arrow,
    effect: $9b11dd5b6cc8a650$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $53b9529f3b2c55a8$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $da9e26b819e4ec3c$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $da9e26b819e4ec3c$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $785327874c9e8d31$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $785327874c9e8d31$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $da9e26b819e4ec3c$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4);
    var sideY = (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $e181b337d8fb704c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $40da45f1d275600f$export$2e2bcd8739ae039)(popper);
            if ((0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d) || (placement === (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4) || placement === (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2)) && variation === (0, $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8)) {
            sideY = (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4) || (placement === (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d) || placement === (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb)) && variation === (0, $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8)) {
            sideX = (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $da9e26b819e4ec3c$var$unsetSides);
    var _ref4 = roundOffsets === true ? $da9e26b819e4ec3c$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $da9e26b819e4ec3c$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $4282b594a1215105$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $da9e26b819e4ec3c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $da9e26b819e4ec3c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $da9e26b819e4ec3c$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $da9e26b819e4ec3c$var$computeStyles,
    data: {}
};



var $be3dff66b8ae1fff$var$passive = {
    passive: true
};
function $be3dff66b8ae1fff$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $be3dff66b8ae1fff$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $be3dff66b8ae1fff$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $be3dff66b8ae1fff$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $be3dff66b8ae1fff$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $be3dff66b8ae1fff$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $be3dff66b8ae1fff$var$effect,
    data: {}
};


var $b60162f4169adb78$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $b60162f4169adb78$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $b60162f4169adb78$var$hash[matched];
    });
}



var $b01c833bc40ef00e$var$hash = {
    start: 'end',
    end: 'start'
};
function $b01c833bc40ef00e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b01c833bc40ef00e$var$hash[matched];
    });
}








function $734609867e74c7ff$export$2e2bcd8739ae039(node) {
    var win = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $ceab813bb971c455$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)((0, $40da45f1d275600f$export$2e2bcd8739ae039)(element)).left + (0, $734609867e74c7ff$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $93abe9672fe14deb$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(element);
    var html = (0, $40da45f1d275600f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $96f81adf64fb639a$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $ceab813bb971c455$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $1d69a071811d963d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $40da45f1d275600f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $734609867e74c7ff$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $785327874c9e8d31$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $785327874c9e8d31$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $ceab813bb971c455$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $785327874c9e8d31$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $9b12b8afd4773621$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $fc74ba96c01207bb$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $303702e262a6ec35$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(node) && (0, $9b12b8afd4773621$export$2e2bcd8739ae039)(node)) return node;
    return $fc74ba96c01207bb$export$2e2bcd8739ae039((0, $9f74b8de57840dbe$export$2e2bcd8739ae039)(node));
}





function $0b3537a9a7580995$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fc74ba96c01207bb$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9b12b8afd4773621$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($0b3537a9a7580995$export$2e2bcd8739ae039((0, $9f74b8de57840dbe$export$2e2bcd8739ae039)(target)));
}










function $d05c6b1dc76e0b14$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3cf3442238779ac6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3cf3442238779ac6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7d6bc8e9bbf80a4b$export$d7b7311ec04a3e8f) ? (0, $d05c6b1dc76e0b14$export$2e2bcd8739ae039)((0, $93abe9672fe14deb$export$2e2bcd8739ae039)(element, strategy)) : (0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(clippingParent) ? $3cf3442238779ac6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d05c6b1dc76e0b14$export$2e2bcd8739ae039)((0, $1d69a071811d963d$export$2e2bcd8739ae039)((0, $40da45f1d275600f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3cf3442238779ac6$var$getClippingParents(element) {
    var clippingParents = (0, $0b3537a9a7580995$export$2e2bcd8739ae039)((0, $9f74b8de57840dbe$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $e746ddabd93b9de2$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(element) ? (0, $e181b337d8fb704c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(clippingParent) && (0, $6f4bb195b9657bfd$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $303702e262a6ec35$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3cf3442238779ac6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3cf3442238779ac6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3cf3442238779ac6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $785327874c9e8d31$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $785327874c9e8d31$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $785327874c9e8d31$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $785327874c9e8d31$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3cf3442238779ac6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $59ee40d543fda46d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $4282b594a1215105$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $43914a77c2347875$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7d6bc8e9bbf80a4b$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7d6bc8e9bbf80a4b$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $6cb24906b58baccb$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7d6bc8e9bbf80a4b$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7d6bc8e9bbf80a4b$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7d6bc8e9bbf80a4b$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $d59b22009de7b956$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $57936895c2815dad$export$2e2bcd8739ae039)(padding, (0, $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7d6bc8e9bbf80a4b$export$ae5ab1c730825774) ? (0, $7d6bc8e9bbf80a4b$export$ca50aac9f3ba507f) : (0, $7d6bc8e9bbf80a4b$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3cf3442238779ac6$export$2e2bcd8739ae039)((0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $40da45f1d275600f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $59ee40d543fda46d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d05c6b1dc76e0b14$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7d6bc8e9bbf80a4b$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7d6bc8e9bbf80a4b$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2),
                (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d),
                (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $7d4e675e13149695$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7d6bc8e9bbf80a4b$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7d6bc8e9bbf80a4b$export$368f9a87e87fa4e1) : (0, $7d6bc8e9bbf80a4b$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7d6bc8e9bbf80a4b$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $6cb24906b58baccb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $4282b594a1215105$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $519bd39db5538ac1$var$getExpandedFallbackPlacements(placement) {
    if ((0, $4282b594a1215105$export$2e2bcd8739ae039)(placement) === (0, $7d6bc8e9bbf80a4b$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $b60162f4169adb78$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b01c833bc40ef00e$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b01c833bc40ef00e$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $519bd39db5538ac1$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $4282b594a1215105$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $b60162f4169adb78$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $519bd39db5538ac1$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $4282b594a1215105$export$2e2bcd8739ae039)(placement) === (0, $7d6bc8e9bbf80a4b$export$dfb5619354ba860) ? (0, $7d4e675e13149695$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $4282b594a1215105$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(placement) === (0, $7d6bc8e9bbf80a4b$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d),
            (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $6cb24906b58baccb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2) : (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb) : (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $b60162f4169adb78$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $b60162f4169adb78$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $519bd39db5538ac1$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $519bd39db5538ac1$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $a0d759f56ba1ef2a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $a0d759f56ba1ef2a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d),
        (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2),
        (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb),
        (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $a0d759f56ba1ef2a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $6cb24906b58baccb$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $6cb24906b58baccb$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $a0d759f56ba1ef2a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $a0d759f56ba1ef2a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $a0d759f56ba1ef2a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $a0d759f56ba1ef2a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $a0d759f56ba1ef2a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $a0d759f56ba1ef2a$var$hide
};




function $39bacdf19877ee23$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $4282b594a1215105$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4),
        (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4),
        (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $39bacdf19877ee23$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7d6bc8e9bbf80a4b$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $39bacdf19877ee23$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $39bacdf19877ee23$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $39bacdf19877ee23$var$offset
};



function $e9276f7d9fbf263d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $59ee40d543fda46d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e9276f7d9fbf263d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e9276f7d9fbf263d$var$popperOffsets,
    data: {}
};





function $8f8c21ac86b5ecaa$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $4ff36eb9022d289d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $6cb24906b58baccb$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $4282b594a1215105$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $53b9529f3b2c55a8$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $43914a77c2347875$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8f8c21ac86b5ecaa$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d) : (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb) : (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7d6bc8e9bbf80a4b$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7d6bc8e9bbf80a4b$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $1db232f53c3f2351$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $49277832eaf9aa5f$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cee56874ccbfb6e6$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $e181b337d8fb704c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cee56874ccbfb6e6$export$f28d906d67a997f3)(tether ? (0, $785327874c9e8d31$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $785327874c9e8d31$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d) : (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7d6bc8e9bbf80a4b$export$40e543e69a8b3fbb) : (0, $7d6bc8e9bbf80a4b$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7d6bc8e9bbf80a4b$export$1e95b668f3b82d),
            (0, $7d6bc8e9bbf80a4b$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cee56874ccbfb6e6$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $cee56874ccbfb6e6$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4ff36eb9022d289d$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4ff36eb9022d289d$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $96a50858d8f845a0$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $40f0f769fcb5d4a5$export$2e2bcd8739ae039(node) {
    if (node === (0, $20233ac2574f9bee$export$2e2bcd8739ae039)(node) || !(0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(node)) return (0, $734609867e74c7ff$export$2e2bcd8739ae039)(node);
    else return (0, $96a50858d8f845a0$export$2e2bcd8739ae039)(node);
}








function $d2ced6c78e61f6d5$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $785327874c9e8d31$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $785327874c9e8d31$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d2ced6c78e61f6d5$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(offsetParent) && $d2ced6c78e61f6d5$var$isElementScaled(offsetParent);
    var documentElement = (0, $40da45f1d275600f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $303702e262a6ec35$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9b12b8afd4773621$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $40f0f769fcb5d4a5$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $7ab7969a804dce04$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f43312ba6dd4c850$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $ceab813bb971c455$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $2b620446aeb1d116$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2b620446aeb1d116$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2b620446aeb1d116$var$order(modifiers); // order based on phase
    return (0, $7d6bc8e9bbf80a4b$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $b6bac2cc1f471df3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $697acadf52df6273$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $10838678ae23ed64$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $10838678ae23ed64$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $10838678ae23ed64$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $10838678ae23ed64$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $10838678ae23ed64$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $7ab7969a804dce04$export$45a5e7f76e0caa8d)(reference) ? (0, $0b3537a9a7580995$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $0b3537a9a7580995$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $0b3537a9a7580995$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2b620446aeb1d116$export$2e2bcd8739ae039)((0, $697acadf52df6273$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$10838678ae23ed64$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d2ced6c78e61f6d5$export$2e2bcd8739ae039)(_$reference, (0, $e181b337d8fb704c$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $1db232f53c3f2351$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b6bac2cc1f471df3$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$10838678ae23ed64$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $10838678ae23ed64$export$8f7491d57c8f97a9 = /*#__PURE__*/ $10838678ae23ed64$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $207128722dcd8d42$export$d34966752335dd47 = [
    (0, $be3dff66b8ae1fff$export$2e2bcd8739ae039),
    (0, $e9276f7d9fbf263d$export$2e2bcd8739ae039),
    (0, $da9e26b819e4ec3c$export$2e2bcd8739ae039),
    (0, $712e6ea51e777f86$export$2e2bcd8739ae039),
    (0, $39bacdf19877ee23$export$2e2bcd8739ae039),
    (0, $519bd39db5538ac1$export$2e2bcd8739ae039),
    (0, $4ff36eb9022d289d$export$2e2bcd8739ae039),
    (0, $9b11dd5b6cc8a650$export$2e2bcd8739ae039),
    (0, $a0d759f56ba1ef2a$export$2e2bcd8739ae039)
];
var $207128722dcd8d42$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $10838678ae23ed64$export$ed5e13716264f202)({
    defaultModifiers: $207128722dcd8d42$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $f45435ef08e25574$export$d34966752335dd47 = [
    (0, $be3dff66b8ae1fff$export$2e2bcd8739ae039),
    (0, $e9276f7d9fbf263d$export$2e2bcd8739ae039),
    (0, $da9e26b819e4ec3c$export$2e2bcd8739ae039),
    (0, $712e6ea51e777f86$export$2e2bcd8739ae039)
];
var $f45435ef08e25574$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $10838678ae23ed64$export$ed5e13716264f202)({
    defaultModifiers: $f45435ef08e25574$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($a66e6eefcf9d6c2e$exports, $7d6bc8e9bbf80a4b$exports);
$parcel$exportWildcard($a66e6eefcf9d6c2e$exports, $920f6fcae42d0d0a$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$elementMap = new Map();
var $5f9c41b37c3854cb$var$Data = {
    set: function(element, key, instance) {
        if (!$5f9c41b37c3854cb$var$elementMap.has(element)) $5f9c41b37c3854cb$var$elementMap.set(element, new Map());
        var instanceMap = $5f9c41b37c3854cb$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($5f9c41b37c3854cb$var$elementMap.has(element)) return $5f9c41b37c3854cb$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$5f9c41b37c3854cb$var$elementMap.has(element)) return;
        var instanceMap = $5f9c41b37c3854cb$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $5f9c41b37c3854cb$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $5f9c41b37c3854cb$var$MAX_UID = 1000000;
var $5f9c41b37c3854cb$var$MILLISECONDS_MULTIPLIER = 1000;
var $5f9c41b37c3854cb$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $5f9c41b37c3854cb$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $5f9c41b37c3854cb$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $5f9c41b37c3854cb$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $5f9c41b37c3854cb$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $5f9c41b37c3854cb$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $5f9c41b37c3854cb$var$MILLISECONDS_MULTIPLIER;
};
var $5f9c41b37c3854cb$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($5f9c41b37c3854cb$var$TRANSITION_END));
};
var $5f9c41b37c3854cb$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $5f9c41b37c3854cb$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($5f9c41b37c3854cb$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($5f9c41b37c3854cb$var$parseSelector(object));
    return null;
};
var $5f9c41b37c3854cb$var$isVisible = function(element) {
    if (!$5f9c41b37c3854cb$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $5f9c41b37c3854cb$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $5f9c41b37c3854cb$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $5f9c41b37c3854cb$var$findShadowRoot(element.parentNode);
};
var $5f9c41b37c3854cb$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $5f9c41b37c3854cb$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $5f9c41b37c3854cb$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $5f9c41b37c3854cb$var$DOMContentLoadedCallbacks = [];
var $5f9c41b37c3854cb$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$5f9c41b37c3854cb$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $5f9c41b37c3854cb$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $5f9c41b37c3854cb$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $5f9c41b37c3854cb$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $5f9c41b37c3854cb$var$defineJQueryPlugin = function(plugin) {
    $5f9c41b37c3854cb$var$onDOMContentLoaded(function() {
        var $ = $5f9c41b37c3854cb$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $5f9c41b37c3854cb$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    var _possibleCallback;
    return typeof possibleCallback === 'function' ? (_possibleCallback = possibleCallback).call.apply(_possibleCallback, (0, $cd50c780af06a876$export$71511d61b312f219)(args)) : defaultValue;
};
var $5f9c41b37c3854cb$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $5f9c41b37c3854cb$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $5f9c41b37c3854cb$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($5f9c41b37c3854cb$var$TRANSITION_END, handler);
        $5f9c41b37c3854cb$var$execute(callback);
    };
    transitionElement.addEventListener($5f9c41b37c3854cb$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $5f9c41b37c3854cb$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $5f9c41b37c3854cb$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $5f9c41b37c3854cb$var$stripNameRegex = /\..*/;
var $5f9c41b37c3854cb$var$stripUidRegex = /::\d+$/;
var $5f9c41b37c3854cb$var$eventRegistry = {}; // Events storage
var $5f9c41b37c3854cb$var$uidEvent = 1;
var $5f9c41b37c3854cb$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $5f9c41b37c3854cb$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $5f9c41b37c3854cb$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($5f9c41b37c3854cb$var$uidEvent++) || element.uidEvent || $5f9c41b37c3854cb$var$uidEvent++;
}
function $5f9c41b37c3854cb$var$getElementEvents(element) {
    var uid = $5f9c41b37c3854cb$var$makeEventUid(element);
    element.uidEvent = uid;
    $5f9c41b37c3854cb$var$eventRegistry[uid] = $5f9c41b37c3854cb$var$eventRegistry[uid] || {};
    return $5f9c41b37c3854cb$var$eventRegistry[uid];
}
function $5f9c41b37c3854cb$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $5f9c41b37c3854cb$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $5f9c41b37c3854cb$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $5f9c41b37c3854cb$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $5f9c41b37c3854cb$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $5f9c41b37c3854cb$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $5f9c41b37c3854cb$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $5f9c41b37c3854cb$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $5f9c41b37c3854cb$var$getTypeEvent(originalTypeEvent);
    if (!$5f9c41b37c3854cb$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $5f9c41b37c3854cb$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $b96fd51f6bb7957d$export$71511d61b312f219)($5f9c41b37c3854cb$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $5f9c41b37c3854cb$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $5f9c41b37c3854cb$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $5f9c41b37c3854cb$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $5f9c41b37c3854cb$var$makeEventUid(callable, originalTypeEvent.replace($5f9c41b37c3854cb$var$namespaceRegex, ''));
    var fn = isDelegated ? $5f9c41b37c3854cb$var$bootstrapDelegationHandler(element, handler, callable) : $5f9c41b37c3854cb$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $5f9c41b37c3854cb$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $5f9c41b37c3854cb$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $5f9c41b37c3854cb$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $5f9c41b37c3854cb$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $5f9c41b37c3854cb$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($5f9c41b37c3854cb$var$stripNameRegex, '');
    return $5f9c41b37c3854cb$var$customEvents[event] || event;
}
var $5f9c41b37c3854cb$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $5f9c41b37c3854cb$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $5f9c41b37c3854cb$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $b96fd51f6bb7957d$export$71511d61b312f219)($5f9c41b37c3854cb$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $5f9c41b37c3854cb$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $5f9c41b37c3854cb$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $5f9c41b37c3854cb$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($5f9c41b37c3854cb$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $5f9c41b37c3854cb$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $5f9c41b37c3854cb$var$getjQuery();
        var typeEvent = $5f9c41b37c3854cb$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $5f9c41b37c3854cb$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $5f9c41b37c3854cb$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $5f9c41b37c3854cb$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $5f9c41b37c3854cb$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $5f9c41b37c3854cb$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($5f9c41b37c3854cb$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($5f9c41b37c3854cb$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = $5f9c41b37c3854cb$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $5f9c41b37c3854cb$var$normalizeData(element.getAttribute("data-bs-".concat($5f9c41b37c3854cb$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $5f9c41b37c3854cb$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Config);
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $5f9c41b37c3854cb$var$isElement(element) ? $5f9c41b37c3854cb$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $532b8962aa050863$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(jsonConfig)) === 'object' ? jsonConfig : {}, $5f9c41b37c3854cb$var$isElement(element) ? $5f9c41b37c3854cb$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $5f9c41b37c3854cb$var$isElement(value) ? 'element' : $5f9c41b37c3854cb$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$VERSION = '5.3.7';
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, BaseComponent);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, BaseComponent);
        element = $5f9c41b37c3854cb$var$getElement(element);
        if (!element) return (0, $cd0610f01f5fdff1$export$71511d61b312f219)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $5f9c41b37c3854cb$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $5f9c41b37c3854cb$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $5f9c41b37c3854cb$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // Private
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $5f9c41b37c3854cb$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $5f9c41b37c3854cb$var$Data.get($5f9c41b37c3854cb$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $5f9c41b37c3854cb$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($5f9c41b37c3854cb$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $5f9c41b37c3854cb$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $5f9c41b37c3854cb$var$parseSelector(sel);
    }).join(',') : null;
};
var $5f9c41b37c3854cb$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$5f9c41b37c3854cb$var$isDisabled(el) && $5f9c41b37c3854cb$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $5f9c41b37c3854cb$var$getSelector(element);
        if (selector) return $5f9c41b37c3854cb$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $5f9c41b37c3854cb$var$getSelector(element);
        return selector ? $5f9c41b37c3854cb$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $5f9c41b37c3854cb$var$getSelector(element);
        return selector ? $5f9c41b37c3854cb$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $5f9c41b37c3854cb$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $5f9c41b37c3854cb$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($5f9c41b37c3854cb$var$isDisabled(this)) return;
        var target = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$f = 'alert';
var $5f9c41b37c3854cb$var$DATA_KEY$a = 'bs.alert';
var $5f9c41b37c3854cb$var$EVENT_KEY$b = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$a);
var $5f9c41b37c3854cb$var$EVENT_CLOSE = "close".concat($5f9c41b37c3854cb$var$EVENT_KEY$b);
var $5f9c41b37c3854cb$var$EVENT_CLOSED = "closed".concat($5f9c41b37c3854cb$var$EVENT_KEY$b);
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE$5 = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Alert, BaseComponent);
    function Alert() {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Alert);
        return (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Alert, arguments);
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$enableDismissTrigger($5f9c41b37c3854cb$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$e = 'button';
var $5f9c41b37c3854cb$var$DATA_KEY$9 = 'bs.button';
var $5f9c41b37c3854cb$var$EVENT_KEY$a = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$9);
var $5f9c41b37c3854cb$var$DATA_API_KEY$6 = '.data-api';
var $5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$3 = 'active';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$6 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$a).concat($5f9c41b37c3854cb$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Button, BaseComponent);
    function Button() {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Button);
        return (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Button, arguments);
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$6, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$5);
    var data = $5f9c41b37c3854cb$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$d = 'swipe';
var $5f9c41b37c3854cb$var$EVENT_KEY$9 = '.bs.swipe';
var $5f9c41b37c3854cb$var$EVENT_TOUCHSTART = "touchstart".concat($5f9c41b37c3854cb$var$EVENT_KEY$9);
var $5f9c41b37c3854cb$var$EVENT_TOUCHMOVE = "touchmove".concat($5f9c41b37c3854cb$var$EVENT_KEY$9);
var $5f9c41b37c3854cb$var$EVENT_TOUCHEND = "touchend".concat($5f9c41b37c3854cb$var$EVENT_KEY$9);
var $5f9c41b37c3854cb$var$EVENT_POINTERDOWN = "pointerdown".concat($5f9c41b37c3854cb$var$EVENT_KEY$9);
var $5f9c41b37c3854cb$var$EVENT_POINTERUP = "pointerup".concat($5f9c41b37c3854cb$var$EVENT_KEY$9);
var $5f9c41b37c3854cb$var$POINTER_TYPE_TOUCH = 'touch';
var $5f9c41b37c3854cb$var$POINTER_TYPE_PEN = 'pen';
var $5f9c41b37c3854cb$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $5f9c41b37c3854cb$var$SWIPE_THRESHOLD = 40;
var $5f9c41b37c3854cb$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $5f9c41b37c3854cb$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Swipe, Config);
    function Swipe(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Swipe);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $cd0610f01f5fdff1$export$71511d61b312f219)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $5f9c41b37c3854cb$var$EventHandler.off(this._element, $5f9c41b37c3854cb$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $5f9c41b37c3854cb$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $5f9c41b37c3854cb$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $5f9c41b37c3854cb$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $5f9c41b37c3854cb$var$POINTER_TYPE_PEN || event.pointerType === $5f9c41b37c3854cb$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($5f9c41b37c3854cb$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$c = 'carousel';
var $5f9c41b37c3854cb$var$DATA_KEY$8 = 'bs.carousel';
var $5f9c41b37c3854cb$var$EVENT_KEY$8 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$8);
var $5f9c41b37c3854cb$var$DATA_API_KEY$5 = '.data-api';
var $5f9c41b37c3854cb$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $5f9c41b37c3854cb$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $5f9c41b37c3854cb$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $5f9c41b37c3854cb$var$ORDER_NEXT = 'next';
var $5f9c41b37c3854cb$var$ORDER_PREV = 'prev';
var $5f9c41b37c3854cb$var$DIRECTION_LEFT = 'left';
var $5f9c41b37c3854cb$var$DIRECTION_RIGHT = 'right';
var $5f9c41b37c3854cb$var$EVENT_SLIDE = "slide".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_SLID = "slid".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN$1 = "keydown".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_DRAG_START = "dragstart".concat($5f9c41b37c3854cb$var$EVENT_KEY$8);
var $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$3 = "load".concat($5f9c41b37c3854cb$var$EVENT_KEY$8).concat($5f9c41b37c3854cb$var$DATA_API_KEY$5);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$5 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$8).concat($5f9c41b37c3854cb$var$DATA_API_KEY$5);
var $5f9c41b37c3854cb$var$CLASS_NAME_CAROUSEL = 'carousel';
var $5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$2 = 'active';
var $5f9c41b37c3854cb$var$CLASS_NAME_SLIDE = 'slide';
var $5f9c41b37c3854cb$var$CLASS_NAME_END = 'carousel-item-end';
var $5f9c41b37c3854cb$var$CLASS_NAME_START = 'carousel-item-start';
var $5f9c41b37c3854cb$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $5f9c41b37c3854cb$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $5f9c41b37c3854cb$var$SELECTOR_ACTIVE = '.active';
var $5f9c41b37c3854cb$var$SELECTOR_ITEM = '.carousel-item';
var $5f9c41b37c3854cb$var$SELECTOR_ACTIVE_ITEM = $5f9c41b37c3854cb$var$SELECTOR_ACTIVE + $5f9c41b37c3854cb$var$SELECTOR_ITEM;
var $5f9c41b37c3854cb$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $5f9c41b37c3854cb$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $5f9c41b37c3854cb$var$_obj;
var $5f9c41b37c3854cb$var$KEY_TO_DIRECTION = ($5f9c41b37c3854cb$var$_obj = {}, (0, $73942673364072c5$export$71511d61b312f219)($5f9c41b37c3854cb$var$_obj, $5f9c41b37c3854cb$var$ARROW_LEFT_KEY$1, $5f9c41b37c3854cb$var$DIRECTION_RIGHT), (0, $73942673364072c5$export$71511d61b312f219)($5f9c41b37c3854cb$var$_obj, $5f9c41b37c3854cb$var$ARROW_RIGHT_KEY$1, $5f9c41b37c3854cb$var$DIRECTION_LEFT), $5f9c41b37c3854cb$var$_obj);
var $5f9c41b37c3854cb$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $5f9c41b37c3854cb$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Carousel);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $5f9c41b37c3854cb$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($5f9c41b37c3854cb$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $5f9c41b37c3854cb$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($5f9c41b37c3854cb$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $5f9c41b37c3854cb$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $5f9c41b37c3854cb$var$EventHandler.one(this._element, $5f9c41b37c3854cb$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $5f9c41b37c3854cb$var$EventHandler.one(this._element, $5f9c41b37c3854cb$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $5f9c41b37c3854cb$var$ORDER_NEXT : $5f9c41b37c3854cb$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $5f9c41b37c3854cb$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $5f9c41b37c3854cb$var$EventHandler.on(img, $5f9c41b37c3854cb$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $5f9c41b37c3854cb$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($5f9c41b37c3854cb$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($5f9c41b37c3854cb$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $5f9c41b37c3854cb$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $5f9c41b37c3854cb$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $5f9c41b37c3854cb$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $5f9c41b37c3854cb$var$ORDER_NEXT;
                var nextElement = element || $5f9c41b37c3854cb$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($5f9c41b37c3854cb$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $5f9c41b37c3854cb$var$CLASS_NAME_START : $5f9c41b37c3854cb$var$CLASS_NAME_END;
                var orderClassName = isNext ? $5f9c41b37c3854cb$var$CLASS_NAME_NEXT : $5f9c41b37c3854cb$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $5f9c41b37c3854cb$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($5f9c41b37c3854cb$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($5f9c41b37c3854cb$var$isRTL()) return direction === $5f9c41b37c3854cb$var$DIRECTION_LEFT ? $5f9c41b37c3854cb$var$ORDER_PREV : $5f9c41b37c3854cb$var$ORDER_NEXT;
                return direction === $5f9c41b37c3854cb$var$DIRECTION_LEFT ? $5f9c41b37c3854cb$var$ORDER_NEXT : $5f9c41b37c3854cb$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($5f9c41b37c3854cb$var$isRTL()) return order === $5f9c41b37c3854cb$var$ORDER_PREV ? $5f9c41b37c3854cb$var$DIRECTION_LEFT : $5f9c41b37c3854cb$var$DIRECTION_RIGHT;
                return order === $5f9c41b37c3854cb$var$ORDER_PREV ? $5f9c41b37c3854cb$var$DIRECTION_RIGHT : $5f9c41b37c3854cb$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$5, $5f9c41b37c3854cb$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $5f9c41b37c3854cb$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($5f9c41b37c3854cb$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $5f9c41b37c3854cb$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$b = 'collapse';
var $5f9c41b37c3854cb$var$DATA_KEY$7 = 'bs.collapse';
var $5f9c41b37c3854cb$var$EVENT_KEY$7 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$7);
var $5f9c41b37c3854cb$var$DATA_API_KEY$4 = '.data-api';
var $5f9c41b37c3854cb$var$EVENT_SHOW$6 = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY$7);
var $5f9c41b37c3854cb$var$EVENT_SHOWN$6 = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY$7);
var $5f9c41b37c3854cb$var$EVENT_HIDE$6 = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY$7);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$6 = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY$7);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$4 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$7).concat($5f9c41b37c3854cb$var$DATA_API_KEY$4);
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$7 = 'show';
var $5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE = 'collapse';
var $5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $5f9c41b37c3854cb$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE, " .").concat($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE);
var $5f9c41b37c3854cb$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $5f9c41b37c3854cb$var$WIDTH = 'width';
var $5f9c41b37c3854cb$var$HEIGHT = 'height';
var $5f9c41b37c3854cb$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $5f9c41b37c3854cb$var$Default$a = {
    parent: null,
    toggle: true
};
var $5f9c41b37c3854cb$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Collapse);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $5f9c41b37c3854cb$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $5f9c41b37c3854cb$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($5f9c41b37c3854cb$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE, $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $5f9c41b37c3854cb$var$reflow(this._element);
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE, $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSE);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            // Private
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $5f9c41b37c3854cb$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_HORIZONTAL) ? $5f9c41b37c3854cb$var$WIDTH : $5f9c41b37c3854cb$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $5f9c41b37c3854cb$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($5f9c41b37c3854cb$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$4, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $5f9c41b37c3854cb$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$a = 'dropdown';
var $5f9c41b37c3854cb$var$DATA_KEY$6 = 'bs.dropdown';
var $5f9c41b37c3854cb$var$EVENT_KEY$6 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$6);
var $5f9c41b37c3854cb$var$DATA_API_KEY$3 = '.data-api';
var $5f9c41b37c3854cb$var$ESCAPE_KEY$2 = 'Escape';
var $5f9c41b37c3854cb$var$TAB_KEY$1 = 'Tab';
var $5f9c41b37c3854cb$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $5f9c41b37c3854cb$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $5f9c41b37c3854cb$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $5f9c41b37c3854cb$var$EVENT_HIDE$5 = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY$6);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$5 = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY$6);
var $5f9c41b37c3854cb$var$EVENT_SHOW$5 = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY$6);
var $5f9c41b37c3854cb$var$EVENT_SHOWN$5 = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY$6);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$3 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$6).concat($5f9c41b37c3854cb$var$DATA_API_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($5f9c41b37c3854cb$var$EVENT_KEY$6).concat($5f9c41b37c3854cb$var$DATA_API_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_KEYUP_DATA_API = "keyup".concat($5f9c41b37c3854cb$var$EVENT_KEY$6).concat($5f9c41b37c3854cb$var$DATA_API_KEY$3);
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6 = 'show';
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPUP = 'dropup';
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPEND = 'dropend';
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPSTART = 'dropstart';
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3, ".").concat($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
var $5f9c41b37c3854cb$var$SELECTOR_MENU = '.dropdown-menu';
var $5f9c41b37c3854cb$var$SELECTOR_NAVBAR = '.navbar';
var $5f9c41b37c3854cb$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $5f9c41b37c3854cb$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $5f9c41b37c3854cb$var$PLACEMENT_TOP = $5f9c41b37c3854cb$var$isRTL() ? 'top-end' : 'top-start';
var $5f9c41b37c3854cb$var$PLACEMENT_TOPEND = $5f9c41b37c3854cb$var$isRTL() ? 'top-start' : 'top-end';
var $5f9c41b37c3854cb$var$PLACEMENT_BOTTOM = $5f9c41b37c3854cb$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $5f9c41b37c3854cb$var$PLACEMENT_BOTTOMEND = $5f9c41b37c3854cb$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $5f9c41b37c3854cb$var$PLACEMENT_RIGHT = $5f9c41b37c3854cb$var$isRTL() ? 'left-start' : 'right-start';
var $5f9c41b37c3854cb$var$PLACEMENT_LEFT = $5f9c41b37c3854cb$var$isRTL() ? 'right-start' : 'left-start';
var $5f9c41b37c3854cb$var$PLACEMENT_TOPCENTER = 'top';
var $5f9c41b37c3854cb$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $5f9c41b37c3854cb$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $5f9c41b37c3854cb$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Dropdown);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $5f9c41b37c3854cb$var$SelectorEngine.next(_this._element, $5f9c41b37c3854cb$var$SELECTOR_MENU)[0] || $5f9c41b37c3854cb$var$SelectorEngine.prev(_this._element, $5f9c41b37c3854cb$var$SELECTOR_MENU)[0] || $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($5f9c41b37c3854cb$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($5f9c41b37c3854cb$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $5f9c41b37c3854cb$var$EventHandler.on(element, 'mouseover', $5f9c41b37c3854cb$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
                $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($5f9c41b37c3854cb$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $5f9c41b37c3854cb$var$EventHandler.off(element, 'mouseover', $5f9c41b37c3854cb$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $5f9c41b37c3854cb$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDDEN$5, relatedTarget);
                // Explicitly return focus to the trigger element
                this._element.focus();
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $cf9fea04db19f9e8$export$71511d61b312f219)(config.reference) === 'object' && !$5f9c41b37c3854cb$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($5f9c41b37c3854cb$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $a66e6eefcf9d6c2e$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($5f9c41b37c3854cb$var$isElement(this._config.reference)) referenceElement = $5f9c41b37c3854cb$var$getElement(this._config.reference);
                else if ((0, $cf9fea04db19f9e8$export$71511d61b312f219)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $a66e6eefcf9d6c2e$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPEND)) return $5f9c41b37c3854cb$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPSTART)) return $5f9c41b37c3854cb$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPUP_CENTER)) return $5f9c41b37c3854cb$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPDOWN_CENTER)) return $5f9c41b37c3854cb$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPUP)) return isEnd ? $5f9c41b37c3854cb$var$PLACEMENT_TOPEND : $5f9c41b37c3854cb$var$PLACEMENT_TOP;
                return isEnd ? $5f9c41b37c3854cb$var$PLACEMENT_BOTTOMEND : $5f9c41b37c3854cb$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($5f9c41b37c3854cb$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $5f9c41b37c3854cb$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $532b8962aa050863$export$71511d61b312f219)({}, defaultBsPopperConfig, $5f9c41b37c3854cb$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $5f9c41b37c3854cb$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $5f9c41b37c3854cb$var$getNextActiveElement(items, target, key === $5f9c41b37c3854cb$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $5f9c41b37c3854cb$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $5f9c41b37c3854cb$var$TAB_KEY$1) return;
                var openToggles = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $5f9c41b37c3854cb$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $5f9c41b37c3854cb$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $5f9c41b37c3854cb$var$ARROW_UP_KEY$1,
                    $5f9c41b37c3854cb$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3) ? this : $5f9c41b37c3854cb$var$SelectorEngine.prev(this, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3)[0] || $5f9c41b37c3854cb$var$SelectorEngine.next(this, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3)[0] || $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DATA_API, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3, $5f9c41b37c3854cb$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DATA_API, $5f9c41b37c3854cb$var$SELECTOR_MENU, $5f9c41b37c3854cb$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$3, $5f9c41b37c3854cb$export$931cbfb6bfb85fc.clearMenus);
$5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_KEYUP_DATA_API, $5f9c41b37c3854cb$export$931cbfb6bfb85fc.clearMenus);
$5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$3, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $5f9c41b37c3854cb$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$9 = 'backdrop';
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE$4 = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$5 = 'show';
var $5f9c41b37c3854cb$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($5f9c41b37c3854cb$var$NAME$9);
var $5f9c41b37c3854cb$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $5f9c41b37c3854cb$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Backdrop, Config);
    function Backdrop(config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Backdrop);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $5f9c41b37c3854cb$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $5f9c41b37c3854cb$var$reflow(element);
                element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $5f9c41b37c3854cb$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $5f9c41b37c3854cb$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $5f9c41b37c3854cb$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $5f9c41b37c3854cb$var$EventHandler.off(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $5f9c41b37c3854cb$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $5f9c41b37c3854cb$var$EventHandler.on(element, $5f9c41b37c3854cb$var$EVENT_MOUSEDOWN, function() {
                    $5f9c41b37c3854cb$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $5f9c41b37c3854cb$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($5f9c41b37c3854cb$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$8 = 'focustrap';
var $5f9c41b37c3854cb$var$DATA_KEY$5 = 'bs.focustrap';
var $5f9c41b37c3854cb$var$EVENT_KEY$5 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$5);
var $5f9c41b37c3854cb$var$EVENT_FOCUSIN$2 = "focusin".concat($5f9c41b37c3854cb$var$EVENT_KEY$5);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($5f9c41b37c3854cb$var$EVENT_KEY$5);
var $5f9c41b37c3854cb$var$TAB_KEY = 'Tab';
var $5f9c41b37c3854cb$var$TAB_NAV_FORWARD = 'forward';
var $5f9c41b37c3854cb$var$TAB_NAV_BACKWARD = 'backward';
var $5f9c41b37c3854cb$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $5f9c41b37c3854cb$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, FocusTrap);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $5f9c41b37c3854cb$var$EventHandler.off(document, $5f9c41b37c3854cb$var$EVENT_KEY$5); // guard against infinite focus loop
                $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $5f9c41b37c3854cb$var$EventHandler.off(document, $5f9c41b37c3854cb$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $5f9c41b37c3854cb$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $5f9c41b37c3854cb$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $5f9c41b37c3854cb$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $5f9c41b37c3854cb$var$TAB_NAV_BACKWARD : $5f9c41b37c3854cb$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($5f9c41b37c3854cb$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $5f9c41b37c3854cb$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $5f9c41b37c3854cb$var$PROPERTY_PADDING = 'padding-right';
var $5f9c41b37c3854cb$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $5f9c41b37c3854cb$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($5f9c41b37c3854cb$var$SELECTOR_FIXED_CONTENT, $5f9c41b37c3854cb$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($5f9c41b37c3854cb$var$SELECTOR_STICKY_CONTENT, $5f9c41b37c3854cb$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $5f9c41b37c3854cb$var$PROPERTY_PADDING);
                this._resetElementAttributes($5f9c41b37c3854cb$var$SELECTOR_FIXED_CONTENT, $5f9c41b37c3854cb$var$PROPERTY_PADDING);
                this._resetElementAttributes($5f9c41b37c3854cb$var$SELECTOR_STICKY_CONTENT, $5f9c41b37c3854cb$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $5f9c41b37c3854cb$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $5f9c41b37c3854cb$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $5f9c41b37c3854cb$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($5f9c41b37c3854cb$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$7 = 'modal';
var $5f9c41b37c3854cb$var$DATA_KEY$4 = 'bs.modal';
var $5f9c41b37c3854cb$var$EVENT_KEY$4 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$4);
var $5f9c41b37c3854cb$var$DATA_API_KEY$2 = '.data-api';
var $5f9c41b37c3854cb$var$ESCAPE_KEY$1 = 'Escape';
var $5f9c41b37c3854cb$var$EVENT_HIDE$4 = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$4 = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_SHOW$4 = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_SHOWN$4 = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_RESIZE$1 = "resize".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($5f9c41b37c3854cb$var$EVENT_KEY$4);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$2 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$4).concat($5f9c41b37c3854cb$var$DATA_API_KEY$2);
var $5f9c41b37c3854cb$var$CLASS_NAME_OPEN = 'modal-open';
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE$3 = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$4 = 'show';
var $5f9c41b37c3854cb$var$CLASS_NAME_STATIC = 'modal-static';
var $5f9c41b37c3854cb$var$OPEN_SELECTOR$1 = '.modal.show';
var $5f9c41b37c3854cb$var$SELECTOR_DIALOG = '.modal-dialog';
var $5f9c41b37c3854cb$var$SELECTOR_MODAL_BODY = '.modal-body';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $5f9c41b37c3854cb$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $5f9c41b37c3854cb$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Modal);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $5f9c41b37c3854cb$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $5f9c41b37c3854cb$var$EventHandler.off(window, $5f9c41b37c3854cb$var$EVENT_KEY$4);
                $5f9c41b37c3854cb$var$EventHandler.off(this._dialog, $5f9c41b37c3854cb$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $5f9c41b37c3854cb$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $5f9c41b37c3854cb$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $5f9c41b37c3854cb$var$reflow(this._element);
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $5f9c41b37c3854cb$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $5f9c41b37c3854cb$var$EventHandler.one(_this._element, $5f9c41b37c3854cb$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $5f9c41b37c3854cb$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $5f9c41b37c3854cb$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$2, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $5f9c41b37c3854cb$var$EventHandler.one(target, $5f9c41b37c3854cb$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $5f9c41b37c3854cb$var$EventHandler.one(target, $5f9c41b37c3854cb$var$EVENT_HIDDEN$4, function() {
            if ($5f9c41b37c3854cb$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $5f9c41b37c3854cb$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $5f9c41b37c3854cb$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$5f9c41b37c3854cb$var$enableDismissTrigger($5f9c41b37c3854cb$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$6 = 'offcanvas';
var $5f9c41b37c3854cb$var$DATA_KEY$3 = 'bs.offcanvas';
var $5f9c41b37c3854cb$var$EVENT_KEY$3 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$3);
var $5f9c41b37c3854cb$var$DATA_API_KEY$1 = '.data-api';
var $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$2 = "load".concat($5f9c41b37c3854cb$var$EVENT_KEY$3).concat($5f9c41b37c3854cb$var$DATA_API_KEY$1);
var $5f9c41b37c3854cb$var$ESCAPE_KEY = 'Escape';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$3 = 'show';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOWING$1 = 'showing';
var $5f9c41b37c3854cb$var$CLASS_NAME_HIDING = 'hiding';
var $5f9c41b37c3854cb$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $5f9c41b37c3854cb$var$OPEN_SELECTOR = '.offcanvas.show';
var $5f9c41b37c3854cb$var$EVENT_SHOW$3 = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_SHOWN$3 = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_HIDE$3 = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$3 = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_RESIZE = "resize".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$1 = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$3).concat($5f9c41b37c3854cb$var$DATA_API_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($5f9c41b37c3854cb$var$EVENT_KEY$3);
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $5f9c41b37c3854cb$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $5f9c41b37c3854cb$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Offcanvas);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $5f9c41b37c3854cb$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOWING$1);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$3, $5f9c41b37c3854cb$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $5f9c41b37c3854cb$var$ScrollBarHelper().reset();
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $5f9c41b37c3854cb$var$Backdrop({
                    className: $5f9c41b37c3854cb$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $5f9c41b37c3854cb$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $5f9c41b37c3854cb$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API$1, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($5f9c41b37c3854cb$var$isDisabled(this)) return;
    $5f9c41b37c3854cb$var$EventHandler.one(target, $5f9c41b37c3854cb$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($5f9c41b37c3854cb$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $5f9c41b37c3854cb$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $5f9c41b37c3854cb$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $5f9c41b37c3854cb$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $5f9c41b37c3854cb$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$5f9c41b37c3854cb$var$enableDismissTrigger($5f9c41b37c3854cb$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $5f9c41b37c3854cb$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $5f9c41b37c3854cb$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $5f9c41b37c3854cb$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $5f9c41b37c3854cb$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ var $5f9c41b37c3854cb$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $5f9c41b37c3854cb$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($5f9c41b37c3854cb$var$uriAttributes.has(attributeName)) return Boolean($5f9c41b37c3854cb$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $5f9c41b37c3854cb$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $cd50c780af06a876$export$71511d61b312f219)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$5f9c41b37c3854cb$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$5 = 'TemplateFactory';
var $5f9c41b37c3854cb$var$Default$4 = {
    allowList: $5f9c41b37c3854cb$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $5f9c41b37c3854cb$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $5f9c41b37c3854cb$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, TemplateFactory);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $532b8962aa050863$export$71511d61b312f219)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $cd50c780af06a876$export$71511d61b312f219)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $5f9c41b37c3854cb$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $5f9c41b37c3854cb$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($5f9c41b37c3854cb$var$isElement(content)) {
                    this._putElementInTemplate($5f9c41b37c3854cb$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $5f9c41b37c3854cb$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $5f9c41b37c3854cb$var$execute(arg, [
                    undefined,
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($5f9c41b37c3854cb$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$4 = 'tooltip';
var $5f9c41b37c3854cb$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE$2 = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_MODAL = 'modal';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$2 = 'show';
var $5f9c41b37c3854cb$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $5f9c41b37c3854cb$var$SELECTOR_MODAL = ".".concat($5f9c41b37c3854cb$var$CLASS_NAME_MODAL);
var $5f9c41b37c3854cb$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $5f9c41b37c3854cb$var$TRIGGER_HOVER = 'hover';
var $5f9c41b37c3854cb$var$TRIGGER_FOCUS = 'focus';
var $5f9c41b37c3854cb$var$TRIGGER_CLICK = 'click';
var $5f9c41b37c3854cb$var$TRIGGER_MANUAL = 'manual';
var $5f9c41b37c3854cb$var$EVENT_HIDE$2 = 'hide';
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$2 = 'hidden';
var $5f9c41b37c3854cb$var$EVENT_SHOW$2 = 'show';
var $5f9c41b37c3854cb$var$EVENT_SHOWN$2 = 'shown';
var $5f9c41b37c3854cb$var$EVENT_INSERTED = 'inserted';
var $5f9c41b37c3854cb$var$EVENT_CLICK$1 = 'click';
var $5f9c41b37c3854cb$var$EVENT_FOCUSIN$1 = 'focusin';
var $5f9c41b37c3854cb$var$EVENT_FOCUSOUT$1 = 'focusout';
var $5f9c41b37c3854cb$var$EVENT_MOUSEENTER = 'mouseenter';
var $5f9c41b37c3854cb$var$EVENT_MOUSELEAVE = 'mouseleave';
var $5f9c41b37c3854cb$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $5f9c41b37c3854cb$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $5f9c41b37c3854cb$var$isRTL() ? 'right' : 'left'
};
var $5f9c41b37c3854cb$var$Default$3 = {
    allowList: $5f9c41b37c3854cb$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $5f9c41b37c3854cb$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Tooltip);
        var _this;
        if (typeof $a66e6eefcf9d6c2e$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $5f9c41b37c3854cb$var$EventHandler.off(this._element.closest($5f9c41b37c3854cb$var$SELECTOR_MODAL), $5f9c41b37c3854cb$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_SHOW$2));
                var shadowRoot = $5f9c41b37c3854cb$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $5f9c41b37c3854cb$var$EventHandler.on(element, 'mouseover', $5f9c41b37c3854cb$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, _this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $cd50c780af06a876$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $5f9c41b37c3854cb$var$EventHandler.off(element, 'mouseover', $5f9c41b37c3854cb$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$5f9c41b37c3854cb$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$5f9c41b37c3854cb$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$5f9c41b37c3854cb$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, _this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_FADE$2, $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $5f9c41b37c3854cb$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $5f9c41b37c3854cb$var$TemplateFactory((0, $b6ff0fef1635ca17$export$71511d61b312f219)((0, $532b8962aa050863$export$71511d61b312f219)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $73942673364072c5$export$71511d61b312f219)({}, $5f9c41b37c3854cb$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $5f9c41b37c3854cb$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $5f9c41b37c3854cb$var$AttachmentMap[placement.toUpperCase()];
                return $a66e6eefcf9d6c2e$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $5f9c41b37c3854cb$var$execute(arg, [
                    this._element,
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $532b8962aa050863$export$71511d61b312f219)({}, defaultBsPopperConfig, $5f9c41b37c3854cb$var$execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $5f9c41b37c3854cb$var$EventHandler.on(this._element, this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context._activeTrigger[$5f9c41b37c3854cb$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$5f9c41b37c3854cb$var$TRIGGER_CLICK]);
                            context.toggle();
                        });
                        else if (trigger !== $5f9c41b37c3854cb$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $5f9c41b37c3854cb$var$TRIGGER_HOVER ? this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_MOUSEENTER) : this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $5f9c41b37c3854cb$var$TRIGGER_HOVER ? this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_MOUSELEAVE) : this.constructor.eventName($5f9c41b37c3854cb$var$EVENT_FOCUSOUT$1);
                            $5f9c41b37c3854cb$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $5f9c41b37c3854cb$var$TRIGGER_FOCUS : $5f9c41b37c3854cb$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $5f9c41b37c3854cb$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $5f9c41b37c3854cb$var$TRIGGER_FOCUS : $5f9c41b37c3854cb$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $5f9c41b37c3854cb$var$EventHandler.on(this._element.closest($5f9c41b37c3854cb$var$SELECTOR_MODAL), $5f9c41b37c3854cb$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $5f9c41b37c3854cb$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($5f9c41b37c3854cb$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $532b8962aa050863$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $5f9c41b37c3854cb$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $b96fd51f6bb7957d$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$3 = 'popover';
var $5f9c41b37c3854cb$var$SELECTOR_TITLE = '.popover-header';
var $5f9c41b37c3854cb$var$SELECTOR_CONTENT = '.popover-body';
var $5f9c41b37c3854cb$var$Default$2 = (0, $b6ff0fef1635ca17$export$71511d61b312f219)((0, $532b8962aa050863$export$71511d61b312f219)({}, $5f9c41b37c3854cb$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $5f9c41b37c3854cb$var$DefaultType$2 = (0, $b6ff0fef1635ca17$export$71511d61b312f219)((0, $532b8962aa050863$export$71511d61b312f219)({}, $5f9c41b37c3854cb$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Popover, Tooltip);
    function Popover() {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Popover);
        return (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Popover, arguments);
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $73942673364072c5$export$71511d61b312f219)(_obj, $5f9c41b37c3854cb$var$SELECTOR_TITLE, this._getTitle()), (0, $73942673364072c5$export$71511d61b312f219)(_obj, $5f9c41b37c3854cb$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($5f9c41b37c3854cb$export$28c660c63b792dea);
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$2 = 'scrollspy';
var $5f9c41b37c3854cb$var$DATA_KEY$2 = 'bs.scrollspy';
var $5f9c41b37c3854cb$var$EVENT_KEY$2 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$2);
var $5f9c41b37c3854cb$var$DATA_API_KEY = '.data-api';
var $5f9c41b37c3854cb$var$EVENT_ACTIVATE = "activate".concat($5f9c41b37c3854cb$var$EVENT_KEY$2);
var $5f9c41b37c3854cb$var$EVENT_CLICK = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$2);
var $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$1 = "load".concat($5f9c41b37c3854cb$var$EVENT_KEY$2).concat($5f9c41b37c3854cb$var$DATA_API_KEY);
var $5f9c41b37c3854cb$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1 = 'active';
var $5f9c41b37c3854cb$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $5f9c41b37c3854cb$var$SELECTOR_TARGET_LINKS = '[href]';
var $5f9c41b37c3854cb$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $5f9c41b37c3854cb$var$SELECTOR_NAV_LINKS = '.nav-link';
var $5f9c41b37c3854cb$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $5f9c41b37c3854cb$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $5f9c41b37c3854cb$var$SELECTOR_LINK_ITEMS = "".concat($5f9c41b37c3854cb$var$SELECTOR_NAV_LINKS, ", ").concat($5f9c41b37c3854cb$var$SELECTOR_NAV_ITEMS, " > ").concat($5f9c41b37c3854cb$var$SELECTOR_NAV_LINKS, ", ").concat($5f9c41b37c3854cb$var$SELECTOR_LIST_ITEMS);
var $5f9c41b37c3854cb$var$SELECTOR_DROPDOWN = '.dropdown';
var $5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $5f9c41b37c3854cb$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $5f9c41b37c3854cb$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, ScrollSpy);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $5f9c41b37c3854cb$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $5f9c41b37c3854cb$var$EventHandler.off(this._config.target, $5f9c41b37c3854cb$var$EVENT_CLICK);
                $5f9c41b37c3854cb$var$EventHandler.on(this._config.target, $5f9c41b37c3854cb$var$EVENT_CLICK, $5f9c41b37c3854cb$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $5f9c41b37c3854cb$var$isDisabled(anchor)) continue;
                        var observableSection = $5f9c41b37c3854cb$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($5f9c41b37c3854cb$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($5f9c41b37c3854cb$var$SELECTOR_DROPDOWN)).classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.parents(target, $5f9c41b37c3854cb$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $5f9c41b37c3854cb$var$SelectorEngine.prev(listGroup, $5f9c41b37c3854cb$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $5f9c41b37c3854cb$var$SelectorEngine.find("".concat($5f9c41b37c3854cb$var$SELECTOR_TARGET_LINKS, ".").concat($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $5f9c41b37c3854cb$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME$1 = 'tab';
var $5f9c41b37c3854cb$var$DATA_KEY$1 = 'bs.tab';
var $5f9c41b37c3854cb$var$EVENT_KEY$1 = ".".concat($5f9c41b37c3854cb$var$DATA_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_HIDE$1 = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN$1 = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_SHOW$1 = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_SHOWN$1 = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API = "click".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_KEYDOWN = "keydown".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API = "load".concat($5f9c41b37c3854cb$var$EVENT_KEY$1);
var $5f9c41b37c3854cb$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $5f9c41b37c3854cb$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $5f9c41b37c3854cb$var$ARROW_UP_KEY = 'ArrowUp';
var $5f9c41b37c3854cb$var$ARROW_DOWN_KEY = 'ArrowDown';
var $5f9c41b37c3854cb$var$HOME_KEY = 'Home';
var $5f9c41b37c3854cb$var$END_KEY = 'End';
var $5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE = 'active';
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE$1 = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$1 = 'show';
var $5f9c41b37c3854cb$var$CLASS_DROPDOWN = 'dropdown';
var $5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $5f9c41b37c3854cb$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $5f9c41b37c3854cb$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $5f9c41b37c3854cb$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $5f9c41b37c3854cb$var$SELECTOR_INNER = ".nav-link".concat($5f9c41b37c3854cb$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($5f9c41b37c3854cb$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($5f9c41b37c3854cb$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $5f9c41b37c3854cb$var$SELECTOR_INNER_ELEM = "".concat($5f9c41b37c3854cb$var$SELECTOR_INNER, ", ").concat($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE);
var $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Tab, BaseComponent);
    function Tab(element) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Tab);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($5f9c41b37c3854cb$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $cd0610f01f5fdff1$export$71511d61b312f219)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $5f9c41b37c3854cb$var$EventHandler.on(_this._element, $5f9c41b37c3854cb$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $5f9c41b37c3854cb$var$EventHandler.trigger(active, $5f9c41b37c3854cb$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(innerElem, $5f9c41b37c3854cb$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE);
                this._activate($5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(element, $5f9c41b37c3854cb$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(element, $5f9c41b37c3854cb$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $5f9c41b37c3854cb$var$ARROW_LEFT_KEY,
                    $5f9c41b37c3854cb$var$ARROW_RIGHT_KEY,
                    $5f9c41b37c3854cb$var$ARROW_UP_KEY,
                    $5f9c41b37c3854cb$var$ARROW_DOWN_KEY,
                    $5f9c41b37c3854cb$var$HOME_KEY,
                    $5f9c41b37c3854cb$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$5f9c41b37c3854cb$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $5f9c41b37c3854cb$var$HOME_KEY,
                    $5f9c41b37c3854cb$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $5f9c41b37c3854cb$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $5f9c41b37c3854cb$var$ARROW_RIGHT_KEY,
                        $5f9c41b37c3854cb$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $5f9c41b37c3854cb$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $5f9c41b37c3854cb$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($5f9c41b37c3854cb$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $5f9c41b37c3854cb$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_TOGGLE, $5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE);
                toggle($5f9c41b37c3854cb$var$SELECTOR_DROPDOWN_MENU, $5f9c41b37c3854cb$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($5f9c41b37c3854cb$var$SELECTOR_INNER_ELEM) ? elem : $5f9c41b37c3854cb$var$SelectorEngine.findOne($5f9c41b37c3854cb$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($5f9c41b37c3854cb$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$EventHandler.on(document, $5f9c41b37c3854cb$var$EVENT_CLICK_DATA_API, $5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($5f9c41b37c3854cb$var$isDisabled(this)) return;
    $5f9c41b37c3854cb$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $5f9c41b37c3854cb$var$EventHandler.on(window, $5f9c41b37c3854cb$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $5f9c41b37c3854cb$var$SelectorEngine.find($5f9c41b37c3854cb$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $5f9c41b37c3854cb$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $5f9c41b37c3854cb$var$NAME = 'toast';
var $5f9c41b37c3854cb$var$DATA_KEY = 'bs.toast';
var $5f9c41b37c3854cb$var$EVENT_KEY = ".".concat($5f9c41b37c3854cb$var$DATA_KEY);
var $5f9c41b37c3854cb$var$EVENT_MOUSEOVER = "mouseover".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_MOUSEOUT = "mouseout".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_FOCUSIN = "focusin".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_FOCUSOUT = "focusout".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_HIDE = "hide".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_HIDDEN = "hidden".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_SHOW = "show".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$EVENT_SHOWN = "shown".concat($5f9c41b37c3854cb$var$EVENT_KEY);
var $5f9c41b37c3854cb$var$CLASS_NAME_FADE = 'fade';
var $5f9c41b37c3854cb$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOW = 'show';
var $5f9c41b37c3854cb$var$CLASS_NAME_SHOWING = 'showing';
var $5f9c41b37c3854cb$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $5f9c41b37c3854cb$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $5f9c41b37c3854cb$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $88a32c98e8928a08$export$71511d61b312f219)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $bc9781ba3abb1241$export$71511d61b312f219)(this, Toast);
        var _this;
        _this = (0, $6e26aa1d62930328$export$71511d61b312f219)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $748a7371a616f526$export$71511d61b312f219)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOWING);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_HIDE); // @deprecated
                $5f9c41b37c3854cb$var$reflow(this._element);
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOW, $5f9c41b37c3854cb$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $5f9c41b37c3854cb$var$EventHandler.trigger(this._element, $5f9c41b37c3854cb$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOWING, $5f9c41b37c3854cb$var$CLASS_NAME_SHOW);
                    $5f9c41b37c3854cb$var$EventHandler.trigger(_this._element, $5f9c41b37c3854cb$var$EVENT_HIDDEN);
                };
                this._element.classList.add($5f9c41b37c3854cb$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($5f9c41b37c3854cb$var$CLASS_NAME_SHOW);
                (0, $4c25d76cb59647ad$export$71511d61b312f219)((0, $46009cb9c7837d26$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($5f9c41b37c3854cb$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $5f9c41b37c3854cb$var$EventHandler.on(this._element, $5f9c41b37c3854cb$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $5f9c41b37c3854cb$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $5f9c41b37c3854cb$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $5f9c41b37c3854cb$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($5f9c41b37c3854cb$var$BaseComponent);
/**
 * Data API implementation
 */ $5f9c41b37c3854cb$var$enableDismissTrigger($5f9c41b37c3854cb$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $5f9c41b37c3854cb$var$defineJQueryPlugin($5f9c41b37c3854cb$export$8d8dc7d5f743331b);



function $6fc24e8e48ddcf68$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6fc24e8e48ddcf68$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6fc24e8e48ddcf68$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6fc24e8e48ddcf68$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $6fc24e8e48ddcf68$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $6fc24e8e48ddcf68$var$CREATED = 1;
var $6fc24e8e48ddcf68$var$MOUNTED = 2;
var $6fc24e8e48ddcf68$var$IDLE = 3;
var $6fc24e8e48ddcf68$var$MOVING = 4;
var $6fc24e8e48ddcf68$var$SCROLLING = 5;
var $6fc24e8e48ddcf68$var$DRAGGING = 6;
var $6fc24e8e48ddcf68$var$DESTROYED = 7;
var $6fc24e8e48ddcf68$var$STATES = {
    CREATED: $6fc24e8e48ddcf68$var$CREATED,
    MOUNTED: $6fc24e8e48ddcf68$var$MOUNTED,
    IDLE: $6fc24e8e48ddcf68$var$IDLE,
    MOVING: $6fc24e8e48ddcf68$var$MOVING,
    SCROLLING: $6fc24e8e48ddcf68$var$SCROLLING,
    DRAGGING: $6fc24e8e48ddcf68$var$DRAGGING,
    DESTROYED: $6fc24e8e48ddcf68$var$DESTROYED
};
function $6fc24e8e48ddcf68$var$empty(array) {
    array.length = 0;
}
function $6fc24e8e48ddcf68$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $6fc24e8e48ddcf68$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($6fc24e8e48ddcf68$var$slice(arguments, 1)));
}
var $6fc24e8e48ddcf68$var$nextTick = setTimeout;
var $6fc24e8e48ddcf68$var$noop = function noop() {};
function $6fc24e8e48ddcf68$var$raf(func) {
    return requestAnimationFrame(func);
}
function $6fc24e8e48ddcf68$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(subject)) === type;
}
function $6fc24e8e48ddcf68$var$isObject(subject) {
    return !$6fc24e8e48ddcf68$var$isNull(subject) && $6fc24e8e48ddcf68$var$typeOf("object", subject);
}
var $6fc24e8e48ddcf68$var$isArray = Array.isArray;
var $6fc24e8e48ddcf68$var$isFunction = $6fc24e8e48ddcf68$var$apply($6fc24e8e48ddcf68$var$typeOf, "function");
var $6fc24e8e48ddcf68$var$isString = $6fc24e8e48ddcf68$var$apply($6fc24e8e48ddcf68$var$typeOf, "string");
var $6fc24e8e48ddcf68$var$isUndefined = $6fc24e8e48ddcf68$var$apply($6fc24e8e48ddcf68$var$typeOf, "undefined");
function $6fc24e8e48ddcf68$var$isNull(subject) {
    return subject === null;
}
function $6fc24e8e48ddcf68$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $6fc24e8e48ddcf68$var$toArray(value) {
    return $6fc24e8e48ddcf68$var$isArray(value) ? value : [
        value
    ];
}
function $6fc24e8e48ddcf68$var$forEach(values, iteratee) {
    $6fc24e8e48ddcf68$var$toArray(values).forEach(iteratee);
}
function $6fc24e8e48ddcf68$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $6fc24e8e48ddcf68$var$push(array, items) {
    array.push.apply(array, $6fc24e8e48ddcf68$var$toArray(items));
    return array;
}
function $6fc24e8e48ddcf68$var$toggleClass(elm, classes, add) {
    if (elm) $6fc24e8e48ddcf68$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $6fc24e8e48ddcf68$var$addClass(elm, classes) {
    $6fc24e8e48ddcf68$var$toggleClass(elm, $6fc24e8e48ddcf68$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $6fc24e8e48ddcf68$var$append(parent, children) {
    $6fc24e8e48ddcf68$var$forEach(children, parent.appendChild.bind(parent));
}
function $6fc24e8e48ddcf68$var$before(nodes, ref) {
    $6fc24e8e48ddcf68$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $6fc24e8e48ddcf68$var$matches(elm, selector) {
    return $6fc24e8e48ddcf68$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $6fc24e8e48ddcf68$var$children(parent, selector) {
    var children2 = parent ? $6fc24e8e48ddcf68$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $6fc24e8e48ddcf68$var$matches(child, selector);
    }) : children2;
}
function $6fc24e8e48ddcf68$var$child(parent, selector) {
    return selector ? $6fc24e8e48ddcf68$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $6fc24e8e48ddcf68$var$ownKeys = Object.keys;
function $6fc24e8e48ddcf68$var$forOwn(object, iteratee, right) {
    if (object) (right ? $6fc24e8e48ddcf68$var$ownKeys(object).reverse() : $6fc24e8e48ddcf68$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $6fc24e8e48ddcf68$var$assign(object) {
    $6fc24e8e48ddcf68$var$slice(arguments, 1).forEach(function(source) {
        $6fc24e8e48ddcf68$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $6fc24e8e48ddcf68$var$merge(object) {
    $6fc24e8e48ddcf68$var$slice(arguments, 1).forEach(function(source) {
        $6fc24e8e48ddcf68$var$forOwn(source, function(value, key) {
            if ($6fc24e8e48ddcf68$var$isArray(value)) object[key] = value.slice();
            else if ($6fc24e8e48ddcf68$var$isObject(value)) object[key] = $6fc24e8e48ddcf68$var$merge({}, $6fc24e8e48ddcf68$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $6fc24e8e48ddcf68$var$omit(object, keys) {
    $6fc24e8e48ddcf68$var$forEach(keys || $6fc24e8e48ddcf68$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $6fc24e8e48ddcf68$var$removeAttribute(elms, attrs) {
    $6fc24e8e48ddcf68$var$forEach(elms, function(elm) {
        $6fc24e8e48ddcf68$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $6fc24e8e48ddcf68$var$setAttribute(elms, attrs, value) {
    if ($6fc24e8e48ddcf68$var$isObject(attrs)) $6fc24e8e48ddcf68$var$forOwn(attrs, function(value2, name) {
        $6fc24e8e48ddcf68$var$setAttribute(elms, name, value2);
    });
    else $6fc24e8e48ddcf68$var$forEach(elms, function(elm) {
        $6fc24e8e48ddcf68$var$isNull(value) || value === "" ? $6fc24e8e48ddcf68$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $6fc24e8e48ddcf68$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $6fc24e8e48ddcf68$var$isString(attrs) ? $6fc24e8e48ddcf68$var$addClass(elm, attrs) : $6fc24e8e48ddcf68$var$setAttribute(elm, attrs);
    parent && $6fc24e8e48ddcf68$var$append(parent, elm);
    return elm;
}
function $6fc24e8e48ddcf68$var$style(elm, prop, value) {
    if ($6fc24e8e48ddcf68$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$6fc24e8e48ddcf68$var$isNull(value)) elm.style[prop] = "" + value;
}
function $6fc24e8e48ddcf68$var$display(elm, display2) {
    $6fc24e8e48ddcf68$var$style(elm, "display", display2);
}
function $6fc24e8e48ddcf68$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $6fc24e8e48ddcf68$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $6fc24e8e48ddcf68$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $6fc24e8e48ddcf68$var$rect(target) {
    return target.getBoundingClientRect();
}
function $6fc24e8e48ddcf68$var$remove(nodes) {
    $6fc24e8e48ddcf68$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $6fc24e8e48ddcf68$var$parseHtml(html) {
    return $6fc24e8e48ddcf68$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $6fc24e8e48ddcf68$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $6fc24e8e48ddcf68$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $6fc24e8e48ddcf68$var$queryAll(parent, selector) {
    return selector ? $6fc24e8e48ddcf68$var$slice(parent.querySelectorAll(selector)) : [];
}
function $6fc24e8e48ddcf68$var$removeClass(elm, classes) {
    $6fc24e8e48ddcf68$var$toggleClass(elm, classes, false);
}
function $6fc24e8e48ddcf68$var$timeOf(e) {
    return e.timeStamp;
}
function $6fc24e8e48ddcf68$var$unit(value) {
    return $6fc24e8e48ddcf68$var$isString(value) ? value : value ? value + "px" : "";
}
var $6fc24e8e48ddcf68$var$PROJECT_CODE = "splide";
var $6fc24e8e48ddcf68$var$DATA_ATTRIBUTE = "data-" + $6fc24e8e48ddcf68$var$PROJECT_CODE;
function $6fc24e8e48ddcf68$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $6fc24e8e48ddcf68$var$PROJECT_CODE + "] " + (message || ""));
}
var $6fc24e8e48ddcf68$var$min = Math.min, $6fc24e8e48ddcf68$var$max = Math.max, $6fc24e8e48ddcf68$var$floor = Math.floor, $6fc24e8e48ddcf68$var$ceil = Math.ceil, $6fc24e8e48ddcf68$var$abs = Math.abs;
function $6fc24e8e48ddcf68$var$approximatelyEqual(x, y, epsilon) {
    return $6fc24e8e48ddcf68$var$abs(x - y) < epsilon;
}
function $6fc24e8e48ddcf68$var$between(number, x, y, exclusive) {
    var minimum = $6fc24e8e48ddcf68$var$min(x, y);
    var maximum = $6fc24e8e48ddcf68$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $6fc24e8e48ddcf68$var$clamp(number, x, y) {
    var minimum = $6fc24e8e48ddcf68$var$min(x, y);
    var maximum = $6fc24e8e48ddcf68$var$max(x, y);
    return $6fc24e8e48ddcf68$var$min($6fc24e8e48ddcf68$var$max(minimum, number), maximum);
}
function $6fc24e8e48ddcf68$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $6fc24e8e48ddcf68$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $6fc24e8e48ddcf68$var$format(string, replacements) {
    $6fc24e8e48ddcf68$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $6fc24e8e48ddcf68$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $6fc24e8e48ddcf68$var$ids = {};
function $6fc24e8e48ddcf68$var$uniqueId(prefix) {
    return "" + prefix + $6fc24e8e48ddcf68$var$pad($6fc24e8e48ddcf68$var$ids[prefix] = ($6fc24e8e48ddcf68$var$ids[prefix] || 0) + 1);
}
function $6fc24e8e48ddcf68$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $6fc24e8e48ddcf68$var$forEach(targets, function(target) {
            target && $6fc24e8e48ddcf68$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $6fc24e8e48ddcf68$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $6fc24e8e48ddcf68$export$d300dc1a2634364b = "mounted";
var $6fc24e8e48ddcf68$export$d8dac49b4532735a = "ready";
var $6fc24e8e48ddcf68$export$2aa493d7c3275167 = "move";
var $6fc24e8e48ddcf68$export$fe5802204b967f0d = "moved";
var $6fc24e8e48ddcf68$export$5adb665701eda1ce = "click";
var $6fc24e8e48ddcf68$export$92e3eae133acac4c = "active";
var $6fc24e8e48ddcf68$export$6bcbb81035c12cea = "inactive";
var $6fc24e8e48ddcf68$export$6a5b3445e4066a53 = "visible";
var $6fc24e8e48ddcf68$export$8c5c7a21d54563e9 = "hidden";
var $6fc24e8e48ddcf68$export$7f4701ac5e05e39f = "refresh";
var $6fc24e8e48ddcf68$export$db40ab7c0855fa5c = "updated";
var $6fc24e8e48ddcf68$export$7e019dae5103a285 = "resize";
var $6fc24e8e48ddcf68$export$d637eba1e9e28482 = "resized";
var $6fc24e8e48ddcf68$export$e84bf5065c9087ac = "drag";
var $6fc24e8e48ddcf68$export$8e9f636d2c722196 = "dragging";
var $6fc24e8e48ddcf68$export$90ea576bd3fdeb60 = "dragged";
var $6fc24e8e48ddcf68$export$49801896908b5e33 = "scroll";
var $6fc24e8e48ddcf68$export$ff8164bff3202b9 = "scrolled";
var $6fc24e8e48ddcf68$export$6cbac5b662a31e1b = "overflow";
var $6fc24e8e48ddcf68$export$88c4cf7419e470cd = "destroy";
var $6fc24e8e48ddcf68$export$8647f6b043e04e9d = "arrows:mounted";
var $6fc24e8e48ddcf68$export$d467f9343b961f75 = "arrows:updated";
var $6fc24e8e48ddcf68$export$bf89a4e4349c9778 = "pagination:mounted";
var $6fc24e8e48ddcf68$export$eb2019082ed6de0b = "pagination:updated";
var $6fc24e8e48ddcf68$export$84015c33508f94ec = "navigation:mounted";
var $6fc24e8e48ddcf68$export$23663268a31b79e2 = "autoplay:play";
var $6fc24e8e48ddcf68$export$185723258309b608 = "autoplay:playing";
var $6fc24e8e48ddcf68$export$16a1e4f3d0368265 = "autoplay:pause";
var $6fc24e8e48ddcf68$export$9f64346e17f0ec8e = "lazyload:loaded";
var $6fc24e8e48ddcf68$export$6d5af59619d10e6a = "sk";
var $6fc24e8e48ddcf68$export$f0af896383d5adff = "sh";
var $6fc24e8e48ddcf68$export$28dea85f216954dc = "ei";
function $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $6fc24e8e48ddcf68$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $6fc24e8e48ddcf68$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $6fc24e8e48ddcf68$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $6fc24e8e48ddcf68$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($6fc24e8e48ddcf68$export$88c4cf7419e470cd, binder.destroy);
    return $6fc24e8e48ddcf68$var$assign(binder, {
        bus: bus,
        on: on,
        off: $6fc24e8e48ddcf68$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $6fc24e8e48ddcf68$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $6fc24e8e48ddcf68$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $6fc24e8e48ddcf68$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $6fc24e8e48ddcf68$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $6fc24e8e48ddcf68$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $6fc24e8e48ddcf68$var$includes($6fc24e8e48ddcf68$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $6fc24e8e48ddcf68$export$efff0f5979573c99(func, duration) {
    var interval = $6fc24e8e48ddcf68$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $6fc24e8e48ddcf68$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $6fc24e8e48ddcf68$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $6fc24e8e48ddcf68$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $6fc24e8e48ddcf68$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($6fc24e8e48ddcf68$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $6fc24e8e48ddcf68$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $6fc24e8e48ddcf68$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($6fc24e8e48ddcf68$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $6fc24e8e48ddcf68$var$merge(options, reducedMotion) : $6fc24e8e48ddcf68$var$omit(options, $6fc24e8e48ddcf68$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $6fc24e8e48ddcf68$var$merge(options, opts);
        base && $6fc24e8e48ddcf68$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($6fc24e8e48ddcf68$var$CREATED)) Splide2.emit($6fc24e8e48ddcf68$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $6fc24e8e48ddcf68$var$ARROW = "Arrow";
var $6fc24e8e48ddcf68$var$ARROW_LEFT = $6fc24e8e48ddcf68$var$ARROW + "Left";
var $6fc24e8e48ddcf68$var$ARROW_RIGHT = $6fc24e8e48ddcf68$var$ARROW + "Right";
var $6fc24e8e48ddcf68$var$ARROW_UP = $6fc24e8e48ddcf68$var$ARROW + "Up";
var $6fc24e8e48ddcf68$var$ARROW_DOWN = $6fc24e8e48ddcf68$var$ARROW + "Down";
var $6fc24e8e48ddcf68$export$373e92e0788ff06e = "ltr";
var $6fc24e8e48ddcf68$export$850f7749a2909601 = "rtl";
var $6fc24e8e48ddcf68$export$97170d9824b89709 = "ttb";
var $6fc24e8e48ddcf68$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $6fc24e8e48ddcf68$var$ARROW_UP,
        $6fc24e8e48ddcf68$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $6fc24e8e48ddcf68$var$ARROW_DOWN,
        $6fc24e8e48ddcf68$var$ARROW_LEFT
    ]
};
function $6fc24e8e48ddcf68$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $6fc24e8e48ddcf68$export$850f7749a2909601 && !axisOnly ? 1 : direction === $6fc24e8e48ddcf68$export$97170d9824b89709 ? 0 : -1;
        return $6fc24e8e48ddcf68$var$ORIENTATION_MAP[prop] && $6fc24e8e48ddcf68$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $6fc24e8e48ddcf68$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $6fc24e8e48ddcf68$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $6fc24e8e48ddcf68$var$ROLE = "role";
var $6fc24e8e48ddcf68$var$TAB_INDEX = "tabindex";
var $6fc24e8e48ddcf68$var$DISABLED = "disabled";
var $6fc24e8e48ddcf68$var$ARIA_PREFIX = "aria-";
var $6fc24e8e48ddcf68$var$ARIA_CONTROLS = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "controls";
var $6fc24e8e48ddcf68$var$ARIA_CURRENT = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "current";
var $6fc24e8e48ddcf68$var$ARIA_SELECTED = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "selected";
var $6fc24e8e48ddcf68$var$ARIA_LABEL = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "label";
var $6fc24e8e48ddcf68$var$ARIA_LABELLEDBY = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "labelledby";
var $6fc24e8e48ddcf68$var$ARIA_HIDDEN = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "hidden";
var $6fc24e8e48ddcf68$var$ARIA_ORIENTATION = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "orientation";
var $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "roledescription";
var $6fc24e8e48ddcf68$var$ARIA_LIVE = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "live";
var $6fc24e8e48ddcf68$var$ARIA_BUSY = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "busy";
var $6fc24e8e48ddcf68$var$ARIA_ATOMIC = $6fc24e8e48ddcf68$var$ARIA_PREFIX + "atomic";
var $6fc24e8e48ddcf68$var$ALL_ATTRIBUTES = [
    $6fc24e8e48ddcf68$var$ROLE,
    $6fc24e8e48ddcf68$var$TAB_INDEX,
    $6fc24e8e48ddcf68$var$DISABLED,
    $6fc24e8e48ddcf68$var$ARIA_CONTROLS,
    $6fc24e8e48ddcf68$var$ARIA_CURRENT,
    $6fc24e8e48ddcf68$var$ARIA_LABEL,
    $6fc24e8e48ddcf68$var$ARIA_LABELLEDBY,
    $6fc24e8e48ddcf68$var$ARIA_HIDDEN,
    $6fc24e8e48ddcf68$var$ARIA_ORIENTATION,
    $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION
];
var $6fc24e8e48ddcf68$var$CLASS_PREFIX = $6fc24e8e48ddcf68$var$PROJECT_CODE + "__";
var $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX = "is-";
var $6fc24e8e48ddcf68$export$93b21159ad85c843 = $6fc24e8e48ddcf68$var$PROJECT_CODE;
var $6fc24e8e48ddcf68$export$7738b09ac0a98952 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "track";
var $6fc24e8e48ddcf68$export$19cc2a5451235cae = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "list";
var $6fc24e8e48ddcf68$export$8d922915837a38d3 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "slide";
var $6fc24e8e48ddcf68$export$2c1ba4a4f1aa4947 = $6fc24e8e48ddcf68$export$8d922915837a38d3 + "--clone";
var $6fc24e8e48ddcf68$export$e9ba7e444ba60a12 = $6fc24e8e48ddcf68$export$8d922915837a38d3 + "__container";
var $6fc24e8e48ddcf68$export$a26cbd955fecf11e = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "arrows";
var $6fc24e8e48ddcf68$export$516e7d18e13a2dca = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "arrow";
var $6fc24e8e48ddcf68$export$58ea3db24c33b76 = $6fc24e8e48ddcf68$export$516e7d18e13a2dca + "--prev";
var $6fc24e8e48ddcf68$export$4885afd7098a65c2 = $6fc24e8e48ddcf68$export$516e7d18e13a2dca + "--next";
var $6fc24e8e48ddcf68$export$cbf8e5a0ab95eda3 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "pagination";
var $6fc24e8e48ddcf68$export$52f2cca6a5eee805 = $6fc24e8e48ddcf68$export$cbf8e5a0ab95eda3 + "__page";
var $6fc24e8e48ddcf68$export$4c82dc32b1c4ace5 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "progress";
var $6fc24e8e48ddcf68$export$2c9b091c749f4409 = $6fc24e8e48ddcf68$export$4c82dc32b1c4ace5 + "__bar";
var $6fc24e8e48ddcf68$export$a29701deef84b825 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "toggle";
var $6fc24e8e48ddcf68$export$d9d247d51b430dbb = $6fc24e8e48ddcf68$export$a29701deef84b825 + "__play";
var $6fc24e8e48ddcf68$export$3529f201a419925b = $6fc24e8e48ddcf68$export$a29701deef84b825 + "__pause";
var $6fc24e8e48ddcf68$export$3e5381ee3fab8374 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "spinner";
var $6fc24e8e48ddcf68$export$bb78d7c200da8960 = $6fc24e8e48ddcf68$var$CLASS_PREFIX + "sr";
var $6fc24e8e48ddcf68$export$7761661e2d5b9388 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "initialized";
var $6fc24e8e48ddcf68$export$72d36ecf3758cb4b = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "active";
var $6fc24e8e48ddcf68$export$e423ac4972f5e196 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "prev";
var $6fc24e8e48ddcf68$export$457a2d20827a2779 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "next";
var $6fc24e8e48ddcf68$export$53ca4621bbab9a = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "visible";
var $6fc24e8e48ddcf68$export$d22ec4ccb7996ba2 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "loading";
var $6fc24e8e48ddcf68$export$b6f202a162a09100 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "focus-in";
var $6fc24e8e48ddcf68$export$cd908cd1dd625e29 = $6fc24e8e48ddcf68$var$STATUS_CLASS_PREFIX + "overflow";
var $6fc24e8e48ddcf68$export$49f9eaea10ebf193 = [
    $6fc24e8e48ddcf68$export$72d36ecf3758cb4b,
    $6fc24e8e48ddcf68$export$53ca4621bbab9a,
    $6fc24e8e48ddcf68$export$e423ac4972f5e196,
    $6fc24e8e48ddcf68$export$457a2d20827a2779,
    $6fc24e8e48ddcf68$export$d22ec4ccb7996ba2,
    $6fc24e8e48ddcf68$export$b6f202a162a09100,
    $6fc24e8e48ddcf68$export$cd908cd1dd625e29
];
var $6fc24e8e48ddcf68$export$ba41d43e4a419565 = {
    slide: $6fc24e8e48ddcf68$export$8d922915837a38d3,
    clone: $6fc24e8e48ddcf68$export$2c1ba4a4f1aa4947,
    arrows: $6fc24e8e48ddcf68$export$a26cbd955fecf11e,
    arrow: $6fc24e8e48ddcf68$export$516e7d18e13a2dca,
    prev: $6fc24e8e48ddcf68$export$58ea3db24c33b76,
    next: $6fc24e8e48ddcf68$export$4885afd7098a65c2,
    pagination: $6fc24e8e48ddcf68$export$cbf8e5a0ab95eda3,
    page: $6fc24e8e48ddcf68$export$52f2cca6a5eee805,
    spinner: $6fc24e8e48ddcf68$export$3e5381ee3fab8374
};
function $6fc24e8e48ddcf68$var$closest(from, selector) {
    if ($6fc24e8e48ddcf68$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($6fc24e8e48ddcf68$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $6fc24e8e48ddcf68$var$FRICTION = 5;
var $6fc24e8e48ddcf68$var$LOG_INTERVAL = 200;
var $6fc24e8e48ddcf68$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $6fc24e8e48ddcf68$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $6fc24e8e48ddcf68$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $6fc24e8e48ddcf68$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, destroy);
        on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, setup);
        on($6fc24e8e48ddcf68$export$db40ab7c0855fa5c, update);
        bind(document, $6fc24e8e48ddcf68$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $6fc24e8e48ddcf68$var$toggleClass(root, $6fc24e8e48ddcf68$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $6fc24e8e48ddcf68$var$ALL_ATTRIBUTES.concat("style");
        $6fc24e8e48ddcf68$var$empty(slides);
        $6fc24e8e48ddcf68$var$removeClass(root, rootClasses);
        $6fc24e8e48ddcf68$var$removeClass(track, trackClasses);
        $6fc24e8e48ddcf68$var$removeAttribute([
            track,
            list
        ], attrs);
        $6fc24e8e48ddcf68$var$removeAttribute(root, completely ? attrs : [
            "style",
            $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $6fc24e8e48ddcf68$var$removeClass(root, rootClasses);
        $6fc24e8e48ddcf68$var$removeClass(track, trackClasses);
        rootClasses = getClasses($6fc24e8e48ddcf68$export$93b21159ad85c843);
        trackClasses = getClasses($6fc24e8e48ddcf68$export$7738b09ac0a98952);
        $6fc24e8e48ddcf68$var$addClass(root, rootClasses);
        $6fc24e8e48ddcf68$var$addClass(track, trackClasses);
        $6fc24e8e48ddcf68$var$setAttribute(root, $6fc24e8e48ddcf68$var$ARIA_LABEL, options.label);
        $6fc24e8e48ddcf68$var$setAttribute(root, $6fc24e8e48ddcf68$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $6fc24e8e48ddcf68$export$7738b09ac0a98952);
        list = $6fc24e8e48ddcf68$var$child(track, "." + $6fc24e8e48ddcf68$export$19cc2a5451235cae);
        $6fc24e8e48ddcf68$var$assert(track && list, "A track/list element is missing.");
        $6fc24e8e48ddcf68$var$push(slides, $6fc24e8e48ddcf68$var$children(list, "." + $6fc24e8e48ddcf68$export$8d922915837a38d3 + ":not(." + $6fc24e8e48ddcf68$export$2c1ba4a4f1aa4947 + ")"));
        $6fc24e8e48ddcf68$var$forOwn({
            arrows: $6fc24e8e48ddcf68$export$a26cbd955fecf11e,
            pagination: $6fc24e8e48ddcf68$export$cbf8e5a0ab95eda3,
            prev: $6fc24e8e48ddcf68$export$58ea3db24c33b76,
            next: $6fc24e8e48ddcf68$export$4885afd7098a65c2,
            bar: $6fc24e8e48ddcf68$export$2c9b091c749f4409,
            toggle: $6fc24e8e48ddcf68$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $6fc24e8e48ddcf68$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $6fc24e8e48ddcf68$var$uniqueId($6fc24e8e48ddcf68$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$6fc24e8e48ddcf68$var$getAttribute(root, $6fc24e8e48ddcf68$var$ROLE) && root.tagName !== "SECTION" && role) $6fc24e8e48ddcf68$var$setAttribute(root, $6fc24e8e48ddcf68$var$ROLE, role);
        $6fc24e8e48ddcf68$var$setAttribute(root, $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $6fc24e8e48ddcf68$var$setAttribute(list, $6fc24e8e48ddcf68$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $6fc24e8e48ddcf68$var$query(root, selector);
        return elm && $6fc24e8e48ddcf68$var$closest(elm, "." + $6fc24e8e48ddcf68$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $6fc24e8e48ddcf68$export$93b21159ad85c843 && $6fc24e8e48ddcf68$export$72d36ecf3758cb4b
        ];
    }
    return $6fc24e8e48ddcf68$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $6fc24e8e48ddcf68$export$e5a58a5ee5b54c22 = "slide";
var $6fc24e8e48ddcf68$export$f42383286ed1223d = "loop";
var $6fc24e8e48ddcf68$export$742b62a5690c060 = "fade";
function $6fc24e8e48ddcf68$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $6fc24e8e48ddcf68$var$getAttribute(slide, "style");
    var label = $6fc24e8e48ddcf68$var$getAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $6fc24e8e48ddcf68$var$child(slide, "." + $6fc24e8e48ddcf68$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $6fc24e8e48ddcf68$var$pad(index + 1);
            $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ROLE, pagination ? "tabpanel" : "group");
            $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_LABEL, label || $6fc24e8e48ddcf68$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $6fc24e8e48ddcf68$var$apply(emit, $6fc24e8e48ddcf68$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $6fc24e8e48ddcf68$var$apply(emit, $6fc24e8e48ddcf68$export$6d5af59619d10e6a, self));
        on([
            $6fc24e8e48ddcf68$export$fe5802204b967f0d,
            $6fc24e8e48ddcf68$export$f0af896383d5adff,
            $6fc24e8e48ddcf68$export$ff8164bff3202b9
        ], update);
        on($6fc24e8e48ddcf68$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($6fc24e8e48ddcf68$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $6fc24e8e48ddcf68$var$removeClass(slide, $6fc24e8e48ddcf68$export$49f9eaea10ebf193);
        $6fc24e8e48ddcf68$var$removeAttribute(slide, $6fc24e8e48ddcf68$var$ALL_ATTRIBUTES);
        $6fc24e8e48ddcf68$var$setAttribute(slide, "style", styles);
        $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_LABEL, $6fc24e8e48ddcf68$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_CONTROLS, controls);
        $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $6fc24e8e48ddcf68$var$removeAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $6fc24e8e48ddcf68$var$toggleClass(slide, $6fc24e8e48ddcf68$export$e423ac4972f5e196, index === curr - 1);
            $6fc24e8e48ddcf68$var$toggleClass(slide, $6fc24e8e48ddcf68$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $6fc24e8e48ddcf68$var$hasClass(slide, $6fc24e8e48ddcf68$export$72d36ecf3758cb4b)) {
            $6fc24e8e48ddcf68$var$toggleClass(slide, $6fc24e8e48ddcf68$export$72d36ecf3758cb4b, active);
            $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $6fc24e8e48ddcf68$export$92e3eae133acac4c : $6fc24e8e48ddcf68$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $6fc24e8e48ddcf68$var$MOVING,
            $6fc24e8e48ddcf68$var$SCROLLING
        ])) $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$ARIA_HIDDEN, hidden || "");
        $6fc24e8e48ddcf68$var$setAttribute($6fc24e8e48ddcf68$var$queryAll(slide, options.focusableNodes || ""), $6fc24e8e48ddcf68$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $6fc24e8e48ddcf68$var$setAttribute(slide, $6fc24e8e48ddcf68$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $6fc24e8e48ddcf68$var$hasClass(slide, $6fc24e8e48ddcf68$export$53ca4621bbab9a)) {
            $6fc24e8e48ddcf68$var$toggleClass(slide, $6fc24e8e48ddcf68$export$53ca4621bbab9a, visible);
            emit(visible ? $6fc24e8e48ddcf68$export$6a5b3445e4066a53 : $6fc24e8e48ddcf68$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $6fc24e8e48ddcf68$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $6fc24e8e48ddcf68$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($6fc24e8e48ddcf68$export$742b62a5690c060)) return isActive();
        var trackRect = $6fc24e8e48ddcf68$var$rect(Components.Elements.track);
        var slideRect = $6fc24e8e48ddcf68$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $6fc24e8e48ddcf68$var$floor(trackRect[left]) <= $6fc24e8e48ddcf68$var$ceil(slideRect[left]) && $6fc24e8e48ddcf68$var$floor(slideRect[right]) <= $6fc24e8e48ddcf68$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $6fc24e8e48ddcf68$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($6fc24e8e48ddcf68$export$f42383286ed1223d))) diff = $6fc24e8e48ddcf68$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $6fc24e8e48ddcf68$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, destroy);
        on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $6fc24e8e48ddcf68$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $6fc24e8e48ddcf68$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $6fc24e8e48ddcf68$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $6fc24e8e48ddcf68$var$forEach(items, function(slide) {
            if ($6fc24e8e48ddcf68$var$isString(slide)) slide = $6fc24e8e48ddcf68$var$parseHtml(slide);
            if ($6fc24e8e48ddcf68$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $6fc24e8e48ddcf68$var$before(slide, ref) : $6fc24e8e48ddcf68$var$append(list, slide);
                $6fc24e8e48ddcf68$var$addClass(slide, options.classes.slide);
                observeImages(slide, $6fc24e8e48ddcf68$var$apply(emit, $6fc24e8e48ddcf68$export$7e019dae5103a285));
            }
        });
        emit($6fc24e8e48ddcf68$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $6fc24e8e48ddcf68$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($6fc24e8e48ddcf68$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($6fc24e8e48ddcf68$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $6fc24e8e48ddcf68$var$isString(matcher) ? $6fc24e8e48ddcf68$var$matches(Slide2.slide, matcher) : $6fc24e8e48ddcf68$var$includes($6fc24e8e48ddcf68$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $6fc24e8e48ddcf68$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $6fc24e8e48ddcf68$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $6fc24e8e48ddcf68$export$efff0f5979573c99($6fc24e8e48ddcf68$var$apply(emit, $6fc24e8e48ddcf68$export$7e019dae5103a285)));
        on([
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
        ], init);
        on($6fc24e8e48ddcf68$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $6fc24e8e48ddcf68$export$97170d9824b89709;
        $6fc24e8e48ddcf68$var$style(root, "maxWidth", $6fc24e8e48ddcf68$var$unit(options.width));
        $6fc24e8e48ddcf68$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $6fc24e8e48ddcf68$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $6fc24e8e48ddcf68$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $6fc24e8e48ddcf68$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $6fc24e8e48ddcf68$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($6fc24e8e48ddcf68$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $6fc24e8e48ddcf68$var$toggleClass(root, $6fc24e8e48ddcf68$export$cd908cd1dd625e29, overflow);
                emit($6fc24e8e48ddcf68$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $6fc24e8e48ddcf68$var$unit(padding[prop] || ($6fc24e8e48ddcf68$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $6fc24e8e48ddcf68$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $6fc24e8e48ddcf68$var$unit(options.height || $6fc24e8e48ddcf68$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $6fc24e8e48ddcf68$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $6fc24e8e48ddcf68$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $6fc24e8e48ddcf68$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $6fc24e8e48ddcf68$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $6fc24e8e48ddcf68$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $6fc24e8e48ddcf68$var$rect(Slide.slide)[resolve("right")];
            var left = $6fc24e8e48ddcf68$var$rect(list)[resolve("left")];
            return $6fc24e8e48ddcf68$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($6fc24e8e48ddcf68$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($6fc24e8e48ddcf68$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($6fc24e8e48ddcf68$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $6fc24e8e48ddcf68$var$MULTIPLIER = 2;
function $6fc24e8e48ddcf68$var$Clones(Splide2, Components2, options) {
    var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, remount);
        on([
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $6fc24e8e48ddcf68$var$remove(clones);
        $6fc24e8e48ddcf68$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($6fc24e8e48ddcf68$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$6fc24e8e48ddcf68$var$push(slides, slides);
            $6fc24e8e48ddcf68$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $6fc24e8e48ddcf68$var$before(clone, slides[0].slide) : $6fc24e8e48ddcf68$var$append(_$Elements.list, clone);
                $6fc24e8e48ddcf68$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $6fc24e8e48ddcf68$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $6fc24e8e48ddcf68$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($6fc24e8e48ddcf68$export$f42383286ed1223d)) clones2 = 0;
        else if ($6fc24e8e48ddcf68$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $6fc24e8e48ddcf68$var$ceil($6fc24e8e48ddcf68$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $6fc24e8e48ddcf68$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $6fc24e8e48ddcf68$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $6fc24e8e48ddcf68$export$d300dc1a2634364b,
            $6fc24e8e48ddcf68$export$d637eba1e9e28482,
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($6fc24e8e48ddcf68$var$MOVING);
        emit($6fc24e8e48ddcf68$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($6fc24e8e48ddcf68$var$IDLE);
            emit($6fc24e8e48ddcf68$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($6fc24e8e48ddcf68$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $6fc24e8e48ddcf68$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($6fc24e8e48ddcf68$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($6fc24e8e48ddcf68$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($6fc24e8e48ddcf68$var$ceil($6fc24e8e48ddcf68$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $6fc24e8e48ddcf68$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $6fc24e8e48ddcf68$var$rect(list)[left] - $6fc24e8e48ddcf68$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22)) position = $6fc24e8e48ddcf68$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $6fc24e8e48ddcf68$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $6fc24e8e48ddcf68$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $6fc24e8e48ddcf68$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($6fc24e8e48ddcf68$export$f42383286ed1223d);
    var isSlide = Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22);
    var getNext = $6fc24e8e48ddcf68$var$apply(getAdjacent, false);
    var getPrev = $6fc24e8e48ddcf68$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f,
            $6fc24e8e48ddcf68$export$28dea85f216954dc
        ], init);
        on($6fc24e8e48ddcf68$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $6fc24e8e48ddcf68$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($6fc24e8e48ddcf68$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $6fc24e8e48ddcf68$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($6fc24e8e48ddcf68$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $6fc24e8e48ddcf68$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$6fc24e8e48ddcf68$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($6fc24e8e48ddcf68$var$between(0, dest, from, true) || $6fc24e8e48ddcf68$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $6fc24e8e48ddcf68$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $6fc24e8e48ddcf68$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $6fc24e8e48ddcf68$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $6fc24e8e48ddcf68$var$min(index, endIndex) : $6fc24e8e48ddcf68$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $6fc24e8e48ddcf68$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$6fc24e8e48ddcf68$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $6fc24e8e48ddcf68$var$MOVING,
            $6fc24e8e48ddcf68$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $6fc24e8e48ddcf68$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $6fc24e8e48ddcf68$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $6fc24e8e48ddcf68$var$SIZE = 40;
function $6fc24e8e48ddcf68$var$Arrows(Splide2, Components2, options) {
    var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($6fc24e8e48ddcf68$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $6fc24e8e48ddcf68$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $6fc24e8e48ddcf68$var$display(wrapper, enabled ? "" : "none");
            $6fc24e8e48ddcf68$var$addClass(wrapper, wrapperClasses = $6fc24e8e48ddcf68$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $6fc24e8e48ddcf68$var$setAttribute([
                    prev,
                    next
                ], $6fc24e8e48ddcf68$var$ARIA_CONTROLS, track.id);
                emit($6fc24e8e48ddcf68$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $6fc24e8e48ddcf68$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $6fc24e8e48ddcf68$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $6fc24e8e48ddcf68$var$removeAttribute([
            prev,
            next
        ], $6fc24e8e48ddcf68$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $6fc24e8e48ddcf68$export$d300dc1a2634364b,
            $6fc24e8e48ddcf68$export$fe5802204b967f0d,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f,
            $6fc24e8e48ddcf68$export$ff8164bff3202b9,
            $6fc24e8e48ddcf68$export$28dea85f216954dc
        ], update);
        bind(next, "click", $6fc24e8e48ddcf68$var$apply(go, ">"));
        bind(prev, "click", $6fc24e8e48ddcf68$var$apply(go, "<"));
    }
    function go(control) {
        _$Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $6fc24e8e48ddcf68$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $6fc24e8e48ddcf68$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $6fc24e8e48ddcf68$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $6fc24e8e48ddcf68$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $6fc24e8e48ddcf68$var$SIZE + " " + $6fc24e8e48ddcf68$var$SIZE + "\" width=\"" + $6fc24e8e48ddcf68$var$SIZE + "\" height=\"" + $6fc24e8e48ddcf68$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $6fc24e8e48ddcf68$var$PATH) + "\" />";
        return $6fc24e8e48ddcf68$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $6fc24e8e48ddcf68$var$setAttribute(prev, $6fc24e8e48ddcf68$var$ARIA_LABEL, prevLabel);
            $6fc24e8e48ddcf68$var$setAttribute(next, $6fc24e8e48ddcf68$var$ARIA_LABEL, nextLabel);
            emit($6fc24e8e48ddcf68$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $6fc24e8e48ddcf68$var$INTERVAL_DATA_ATTRIBUTE = $6fc24e8e48ddcf68$var$DATA_ATTRIBUTE + "-interval";
function $6fc24e8e48ddcf68$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $6fc24e8e48ddcf68$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $6fc24e8e48ddcf68$var$setAttribute(toggle, $6fc24e8e48ddcf68$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $6fc24e8e48ddcf68$export$2aa493d7c3275167,
            $6fc24e8e48ddcf68$export$49801896908b5e33,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($6fc24e8e48ddcf68$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($6fc24e8e48ddcf68$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($6fc24e8e48ddcf68$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $6fc24e8e48ddcf68$var$toggleClass(toggle, $6fc24e8e48ddcf68$export$72d36ecf3758cb4b, !stopped);
            $6fc24e8e48ddcf68$var$setAttribute(toggle, $6fc24e8e48ddcf68$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $6fc24e8e48ddcf68$var$style(bar, "width", rate * 100 + "%");
        emit($6fc24e8e48ddcf68$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$6fc24e8e48ddcf68$var$getAttribute(Slide.slide, $6fc24e8e48ddcf68$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $6fc24e8e48ddcf68$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($6fc24e8e48ddcf68$export$9f64346e17f0ec8e, $6fc24e8e48ddcf68$var$apply(toggle, true));
            on([
                $6fc24e8e48ddcf68$export$d300dc1a2634364b,
                $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
                $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
            ], $6fc24e8e48ddcf68$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $6fc24e8e48ddcf68$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $6fc24e8e48ddcf68$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $6fc24e8e48ddcf68$var$apply(cover, false)
    };
}
var $6fc24e8e48ddcf68$var$BOUNCE_DIFF_THRESHOLD = 10;
var $6fc24e8e48ddcf68$var$BOUNCE_DURATION = 600;
var $6fc24e8e48ddcf68$var$FRICTION_FACTOR = 0.6;
var $6fc24e8e48ddcf68$var$BASE_VELOCITY = 1.5;
var $6fc24e8e48ddcf68$var$MIN_DURATION = 800;
function $6fc24e8e48ddcf68$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($6fc24e8e48ddcf68$export$2aa493d7c3275167, clear);
        on([
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $6fc24e8e48ddcf68$var$sign(destination) * size * $6fc24e8e48ddcf68$var$floor($6fc24e8e48ddcf68$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $6fc24e8e48ddcf68$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $6fc24e8e48ddcf68$var$max($6fc24e8e48ddcf68$var$abs(destination - from) / $6fc24e8e48ddcf68$var$BASE_VELOCITY, $6fc24e8e48ddcf68$var$MIN_DURATION);
        callback = onScrolled;
        interval = $6fc24e8e48ddcf68$export$46ad21b25b6dccf0(duration, onEnd, $6fc24e8e48ddcf68$var$apply(update, from, destination, noConstrain), 1);
        set($6fc24e8e48ddcf68$var$SCROLLING);
        emit($6fc24e8e48ddcf68$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($6fc24e8e48ddcf68$var$IDLE);
        callback && callback();
        emit($6fc24e8e48ddcf68$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $6fc24e8e48ddcf68$var$FRICTION_FACTOR;
            if ($6fc24e8e48ddcf68$var$abs(diff) < $6fc24e8e48ddcf68$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $6fc24e8e48ddcf68$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $6fc24e8e48ddcf68$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $6fc24e8e48ddcf68$var$POINTER_MOVE_EVENTS, $6fc24e8e48ddcf68$var$noop, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $6fc24e8e48ddcf68$var$POINTER_UP_EVENTS, $6fc24e8e48ddcf68$var$noop, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $6fc24e8e48ddcf68$var$POINTER_DOWN_EVENTS, onPointerDown, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $6fc24e8e48ddcf68$var$prevent);
        on([
            $6fc24e8e48ddcf68$export$d300dc1a2634364b,
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $6fc24e8e48ddcf68$var$MOVING,
                        $6fc24e8e48ddcf68$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $6fc24e8e48ddcf68$var$POINTER_MOVE_EVENTS, onPointerMove, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $6fc24e8e48ddcf68$var$POINTER_UP_EVENTS, onPointerUp, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $6fc24e8e48ddcf68$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($6fc24e8e48ddcf68$var$DRAGGING)) {
            state.set($6fc24e8e48ddcf68$var$DRAGGING);
            emit($6fc24e8e48ddcf68$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $6fc24e8e48ddcf68$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($6fc24e8e48ddcf68$export$8e9f636d2c722196);
                $6fc24e8e48ddcf68$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $6fc24e8e48ddcf68$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($6fc24e8e48ddcf68$var$DRAGGING)) {
            state.set($6fc24e8e48ddcf68$var$IDLE);
            emit($6fc24e8e48ddcf68$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $6fc24e8e48ddcf68$var$prevent(e);
        }
        unbind(target, $6fc24e8e48ddcf68$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $6fc24e8e48ddcf68$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $6fc24e8e48ddcf68$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($6fc24e8e48ddcf68$export$742b62a5690c060)) _$Controller.go(orient($6fc24e8e48ddcf68$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $6fc24e8e48ddcf68$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $6fc24e8e48ddcf68$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $6fc24e8e48ddcf68$var$abs(diffCoord(e)) > $6fc24e8e48ddcf68$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($6fc24e8e48ddcf68$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $6fc24e8e48ddcf68$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $6fc24e8e48ddcf68$var$sign(velocity) * $6fc24e8e48ddcf68$var$min($6fc24e8e48ddcf68$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $6fc24e8e48ddcf68$var$timeOf(e) - $6fc24e8e48ddcf68$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22) ? $6fc24e8e48ddcf68$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$6fc24e8e48ddcf68$var$matches(target2, "." + $6fc24e8e48ddcf68$export$52f2cca6a5eee805 + ", ." + $6fc24e8e48ddcf68$export$516e7d18e13a2dca) && (!noDrag || !$6fc24e8e48ddcf68$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $6fc24e8e48ddcf68$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $6fc24e8e48ddcf68$var$ARROW_RIGHT,
    Left: $6fc24e8e48ddcf68$var$ARROW_LEFT,
    Up: $6fc24e8e48ddcf68$var$ARROW_UP,
    Down: $6fc24e8e48ddcf68$var$ARROW_DOWN
};
function $6fc24e8e48ddcf68$var$normalizeKey(key) {
    key = $6fc24e8e48ddcf68$var$isString(key) ? key : key.key;
    return $6fc24e8e48ddcf68$var$NORMALIZATION_MAP[key] || key;
}
var $6fc24e8e48ddcf68$var$KEYBOARD_EVENT = "keydown";
function $6fc24e8e48ddcf68$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($6fc24e8e48ddcf68$export$db40ab7c0855fa5c, destroy);
        on($6fc24e8e48ddcf68$export$db40ab7c0855fa5c, init);
        on($6fc24e8e48ddcf68$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $6fc24e8e48ddcf68$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $6fc24e8e48ddcf68$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $6fc24e8e48ddcf68$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $6fc24e8e48ddcf68$var$normalizeKey(e);
            if (key === resolve($6fc24e8e48ddcf68$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($6fc24e8e48ddcf68$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE = $6fc24e8e48ddcf68$var$DATA_ATTRIBUTE + "-lazy";
var $6fc24e8e48ddcf68$var$SRCSET_DATA_ATTRIBUTE = $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $6fc24e8e48ddcf68$var$IMAGE_SELECTOR = "[" + $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE + "], [" + $6fc24e8e48ddcf68$var$SRCSET_DATA_ATTRIBUTE + "]";
function $6fc24e8e48ddcf68$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $6fc24e8e48ddcf68$export$fe5802204b967f0d,
        $6fc24e8e48ddcf68$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($6fc24e8e48ddcf68$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $6fc24e8e48ddcf68$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $6fc24e8e48ddcf68$var$queryAll(Slide.slide, $6fc24e8e48ddcf68$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $6fc24e8e48ddcf68$var$getAttribute(img, $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE);
                var srcset = $6fc24e8e48ddcf68$var$getAttribute(img, $6fc24e8e48ddcf68$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $6fc24e8e48ddcf68$var$child(parent, "." + className) || $6fc24e8e48ddcf68$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $6fc24e8e48ddcf68$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $6fc24e8e48ddcf68$var$addClass(data[1].slide, $6fc24e8e48ddcf68$export$d22ec4ccb7996ba2);
        bind(img, "load error", $6fc24e8e48ddcf68$var$apply(onLoad, data));
        $6fc24e8e48ddcf68$var$setAttribute(img, "src", $6fc24e8e48ddcf68$var$getAttribute(img, $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE));
        $6fc24e8e48ddcf68$var$setAttribute(img, "srcset", $6fc24e8e48ddcf68$var$getAttribute(img, $6fc24e8e48ddcf68$var$SRCSET_DATA_ATTRIBUTE));
        $6fc24e8e48ddcf68$var$removeAttribute(img, $6fc24e8e48ddcf68$var$SRC_DATA_ATTRIBUTE);
        $6fc24e8e48ddcf68$var$removeAttribute(img, $6fc24e8e48ddcf68$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $6fc24e8e48ddcf68$var$removeClass(Slide.slide, $6fc24e8e48ddcf68$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $6fc24e8e48ddcf68$var$remove(data[2]);
            $6fc24e8e48ddcf68$var$display(img, "");
            emit($6fc24e8e48ddcf68$export$9f64346e17f0ec8e, img, Slide);
            emit($6fc24e8e48ddcf68$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $6fc24e8e48ddcf68$var$apply($6fc24e8e48ddcf68$var$empty, entries),
        check: check
    };
}
function $6fc24e8e48ddcf68$var$Pagination(Splide2, Components2, options) {
    var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f,
            $6fc24e8e48ddcf68$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $6fc24e8e48ddcf68$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $6fc24e8e48ddcf68$export$2aa493d7c3275167,
                $6fc24e8e48ddcf68$export$49801896908b5e33,
                $6fc24e8e48ddcf68$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($6fc24e8e48ddcf68$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $6fc24e8e48ddcf68$var$remove(placeholder ? $6fc24e8e48ddcf68$var$slice(list.children) : list);
            $6fc24e8e48ddcf68$var$removeClass(list, paginationClasses);
            $6fc24e8e48ddcf68$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $6fc24e8e48ddcf68$var$ceil(length / perPage);
        list = placeholder || $6fc24e8e48ddcf68$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $6fc24e8e48ddcf68$var$addClass(list, paginationClasses = $6fc24e8e48ddcf68$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $6fc24e8e48ddcf68$var$setAttribute(list, $6fc24e8e48ddcf68$var$ROLE, "tablist");
        $6fc24e8e48ddcf68$var$setAttribute(list, $6fc24e8e48ddcf68$var$ARIA_LABEL, i18n.select);
        $6fc24e8e48ddcf68$var$setAttribute(list, $6fc24e8e48ddcf68$var$ARIA_ORIENTATION, getDirection() === $6fc24e8e48ddcf68$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $6fc24e8e48ddcf68$var$create("li", null, list);
            var button = $6fc24e8e48ddcf68$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $6fc24e8e48ddcf68$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $6fc24e8e48ddcf68$var$apply(onKeydown, i));
            $6fc24e8e48ddcf68$var$setAttribute(li, $6fc24e8e48ddcf68$var$ROLE, "presentation");
            $6fc24e8e48ddcf68$var$setAttribute(button, $6fc24e8e48ddcf68$var$ROLE, "tab");
            $6fc24e8e48ddcf68$var$setAttribute(button, $6fc24e8e48ddcf68$var$ARIA_CONTROLS, controls.join(" "));
            $6fc24e8e48ddcf68$var$setAttribute(button, $6fc24e8e48ddcf68$var$ARIA_LABEL, $6fc24e8e48ddcf68$var$format(text, i + 1));
            $6fc24e8e48ddcf68$var$setAttribute(button, $6fc24e8e48ddcf68$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $6fc24e8e48ddcf68$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($6fc24e8e48ddcf68$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($6fc24e8e48ddcf68$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $6fc24e8e48ddcf68$var$focus(item.button);
            go(">" + nextPage);
            $6fc24e8e48ddcf68$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[_$Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $6fc24e8e48ddcf68$var$removeClass(button, $6fc24e8e48ddcf68$export$72d36ecf3758cb4b);
            $6fc24e8e48ddcf68$var$removeAttribute(button, $6fc24e8e48ddcf68$var$ARIA_SELECTED);
            $6fc24e8e48ddcf68$var$setAttribute(button, $6fc24e8e48ddcf68$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $6fc24e8e48ddcf68$var$addClass(_button, $6fc24e8e48ddcf68$export$72d36ecf3758cb4b);
            $6fc24e8e48ddcf68$var$setAttribute(_button, $6fc24e8e48ddcf68$var$ARIA_SELECTED, true);
            $6fc24e8e48ddcf68$var$setAttribute(_button, $6fc24e8e48ddcf68$var$TAB_INDEX, "");
        }
        emit($6fc24e8e48ddcf68$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $6fc24e8e48ddcf68$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $6fc24e8e48ddcf68$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $6fc24e8e48ddcf68$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(splide);
        event.on($6fc24e8e48ddcf68$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($6fc24e8e48ddcf68$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($6fc24e8e48ddcf68$export$5adb665701eda1ce, onClick);
        on($6fc24e8e48ddcf68$export$6d5af59619d10e6a, onKeydown);
        on([
            $6fc24e8e48ddcf68$export$d300dc1a2634364b,
            $6fc24e8e48ddcf68$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($6fc24e8e48ddcf68$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $6fc24e8e48ddcf68$var$setAttribute(Components2.Elements.list, $6fc24e8e48ddcf68$var$ARIA_ORIENTATION, options.direction === $6fc24e8e48ddcf68$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($6fc24e8e48ddcf68$var$includes($6fc24e8e48ddcf68$var$TRIGGER_KEYS, $6fc24e8e48ddcf68$var$normalizeKey(e))) {
            onClick(Slide);
            $6fc24e8e48ddcf68$var$prevent(e);
        }
    }
    return {
        setup: $6fc24e8e48ddcf68$var$apply(Components2.Media.set, {
            slideFocus: $6fc24e8e48ddcf68$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $6fc24e8e48ddcf68$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $6fc24e8e48ddcf68$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $6fc24e8e48ddcf68$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($6fc24e8e48ddcf68$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $6fc24e8e48ddcf68$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($6fc24e8e48ddcf68$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $6fc24e8e48ddcf68$var$SR_REMOVAL_DELAY = 90;
function $6fc24e8e48ddcf68$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $6fc24e8e48ddcf68$var$create("span", $6fc24e8e48ddcf68$export$bb78d7c200da8960);
    var interval = $6fc24e8e48ddcf68$export$46ad21b25b6dccf0($6fc24e8e48ddcf68$var$SR_REMOVAL_DELAY, $6fc24e8e48ddcf68$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $6fc24e8e48ddcf68$var$setAttribute(track, $6fc24e8e48ddcf68$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($6fc24e8e48ddcf68$export$23663268a31b79e2, $6fc24e8e48ddcf68$var$apply(disable, true));
            on($6fc24e8e48ddcf68$export$16a1e4f3d0368265, $6fc24e8e48ddcf68$var$apply(disable, false));
            on([
                $6fc24e8e48ddcf68$export$fe5802204b967f0d,
                $6fc24e8e48ddcf68$export$ff8164bff3202b9
            ], $6fc24e8e48ddcf68$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $6fc24e8e48ddcf68$var$setAttribute(track, $6fc24e8e48ddcf68$var$ARIA_BUSY, active);
        if (active) {
            $6fc24e8e48ddcf68$var$append(track, sr);
            interval.start();
        } else {
            $6fc24e8e48ddcf68$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $6fc24e8e48ddcf68$var$removeAttribute(track, [
            $6fc24e8e48ddcf68$var$ARIA_LIVE,
            $6fc24e8e48ddcf68$var$ARIA_ATOMIC,
            $6fc24e8e48ddcf68$var$ARIA_BUSY
        ]);
        $6fc24e8e48ddcf68$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $6fc24e8e48ddcf68$var$setAttribute(track, $6fc24e8e48ddcf68$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $6fc24e8e48ddcf68$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $6fc24e8e48ddcf68$var$Media,
    Direction: $6fc24e8e48ddcf68$var$Direction,
    Elements: $6fc24e8e48ddcf68$var$Elements,
    Slides: $6fc24e8e48ddcf68$var$Slides,
    Layout: $6fc24e8e48ddcf68$var$Layout,
    Clones: $6fc24e8e48ddcf68$var$Clones,
    Move: $6fc24e8e48ddcf68$var$Move,
    Controller: $6fc24e8e48ddcf68$var$Controller,
    Arrows: $6fc24e8e48ddcf68$var$Arrows,
    Autoplay: $6fc24e8e48ddcf68$var$Autoplay,
    Cover: $6fc24e8e48ddcf68$var$Cover,
    Scroll: $6fc24e8e48ddcf68$var$Scroll,
    Drag: $6fc24e8e48ddcf68$var$Drag,
    Keyboard: $6fc24e8e48ddcf68$var$Keyboard,
    LazyLoad: $6fc24e8e48ddcf68$var$LazyLoad,
    Pagination: $6fc24e8e48ddcf68$var$Pagination,
    Sync: $6fc24e8e48ddcf68$var$Sync,
    Wheel: $6fc24e8e48ddcf68$var$Wheel,
    Live: $6fc24e8e48ddcf68$var$Live
});
var $6fc24e8e48ddcf68$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $6fc24e8e48ddcf68$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $6fc24e8e48ddcf68$export$ba41d43e4a419565,
    i18n: $6fc24e8e48ddcf68$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $6fc24e8e48ddcf68$var$Fade(Splide2, Components2, options) {
    var _$Slides = Components2.Slides;
    function mount() {
        $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2).on([
            $6fc24e8e48ddcf68$export$d300dc1a2634364b,
            $6fc24e8e48ddcf68$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $6fc24e8e48ddcf68$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $6fc24e8e48ddcf68$var$noop
    };
}
function $6fc24e8e48ddcf68$var$Slide(Splide2, Components2, options) {
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $6fc24e8e48ddcf68$var$apply($6fc24e8e48ddcf68$var$style, list, "transition");
    var endCallback;
    function mount() {
        $6fc24e8e48ddcf68$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($6fc24e8e48ddcf68$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        _$Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($6fc24e8e48ddcf68$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $6fc24e8e48ddcf68$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $6fc24e8e48ddcf68$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $6fc24e8e48ddcf68$export$7254cc27399e90bd($6fc24e8e48ddcf68$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $6fc24e8e48ddcf68$var$isString(target) ? $6fc24e8e48ddcf68$var$query(document, target) : target;
        $6fc24e8e48ddcf68$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $6fc24e8e48ddcf68$var$merge({
            label: $6fc24e8e48ddcf68$var$getAttribute(root, $6fc24e8e48ddcf68$var$ARIA_LABEL) || "",
            labelledby: $6fc24e8e48ddcf68$var$getAttribute(root, $6fc24e8e48ddcf68$var$ARIA_LABELLEDBY) || ""
        }, $6fc24e8e48ddcf68$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $6fc24e8e48ddcf68$var$merge(options, JSON.parse($6fc24e8e48ddcf68$var$getAttribute(root, $6fc24e8e48ddcf68$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $6fc24e8e48ddcf68$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($6fc24e8e48ddcf68$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $6fc24e8e48ddcf68$var$assert(state.is([
            $6fc24e8e48ddcf68$var$CREATED,
            $6fc24e8e48ddcf68$var$DESTROYED
        ]), "Already mounted!");
        state.set($6fc24e8e48ddcf68$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($6fc24e8e48ddcf68$export$742b62a5690c060) ? $6fc24e8e48ddcf68$var$Fade : $6fc24e8e48ddcf68$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $6fc24e8e48ddcf68$var$assign({}, $6fc24e8e48ddcf68$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $6fc24e8e48ddcf68$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $6fc24e8e48ddcf68$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($6fc24e8e48ddcf68$export$d300dc1a2634364b);
        $6fc24e8e48ddcf68$var$addClass(this.root, $6fc24e8e48ddcf68$export$7761661e2d5b9388);
        state.set($6fc24e8e48ddcf68$var$IDLE);
        this.emit($6fc24e8e48ddcf68$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($6fc24e8e48ddcf68$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($6fc24e8e48ddcf68$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($6fc24e8e48ddcf68$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($6fc24e8e48ddcf68$var$CREATED)) $6fc24e8e48ddcf68$export$f188226459c8a3ff(this).on($6fc24e8e48ddcf68$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $6fc24e8e48ddcf68$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($6fc24e8e48ddcf68$export$88c4cf7419e470cd);
            event.destroy();
            completely && $6fc24e8e48ddcf68$var$empty(this.splides);
            state.set($6fc24e8e48ddcf68$var$DESTROYED);
        }
        return this;
    };
    $6fc24e8e48ddcf68$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $6fc24e8e48ddcf68$export$24494c7438c070bf = $6fc24e8e48ddcf68$var$_Splide;
$6fc24e8e48ddcf68$export$24494c7438c070bf.defaults = {};
$6fc24e8e48ddcf68$export$24494c7438c070bf.STATES = $6fc24e8e48ddcf68$var$STATES;
var $6fc24e8e48ddcf68$var$CLASS_RENDERED = "is-rendered";
var $6fc24e8e48ddcf68$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $6fc24e8e48ddcf68$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $6fc24e8e48ddcf68$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $6fc24e8e48ddcf68$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $6fc24e8e48ddcf68$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $6fc24e8e48ddcf68$var$merge($6fc24e8e48ddcf68$export$f484e977a69c6ba6, defaults || {});
        $6fc24e8e48ddcf68$var$merge($6fc24e8e48ddcf68$var$merge(this.options, $6fc24e8e48ddcf68$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $6fc24e8e48ddcf68$var$assign({}, $6fc24e8e48ddcf68$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $6fc24e8e48ddcf68$var$uniqueId("splide");
        this.Style = new $6fc24e8e48ddcf68$var$Style(this.id, this.options);
        this.Direction = $6fc24e8e48ddcf68$var$Direction(null, null, this.options);
        $6fc24e8e48ddcf68$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $6fc24e8e48ddcf68$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $6fc24e8e48ddcf68$var$queryAll(root, "." + $6fc24e8e48ddcf68$export$2c1ba4a4f1aa4947);
        on($6fc24e8e48ddcf68$export$d300dc1a2634364b, function() {
            $6fc24e8e48ddcf68$var$remove($6fc24e8e48ddcf68$var$child(root, "style"));
        });
        $6fc24e8e48ddcf68$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $6fc24e8e48ddcf68$var$push(this.slides, this.contents.map(function(content, index) {
            content = $6fc24e8e48ddcf68$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $6fc24e8e48ddcf68$export$72d36ecf3758cb4b : "");
            $6fc24e8e48ddcf68$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $6fc24e8e48ddcf68$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $6fc24e8e48ddcf68$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $6fc24e8e48ddcf68$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $6fc24e8e48ddcf68$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $6fc24e8e48ddcf68$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $6fc24e8e48ddcf68$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $6fc24e8e48ddcf68$var$unit(padding[prop] || ($6fc24e8e48ddcf68$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $6fc24e8e48ddcf68$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $6fc24e8e48ddcf68$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $6fc24e8e48ddcf68$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $6fc24e8e48ddcf68$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $6fc24e8e48ddcf68$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($6fc24e8e48ddcf68$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $6fc24e8e48ddcf68$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $6fc24e8e48ddcf68$var$merge($6fc24e8e48ddcf68$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $6fc24e8e48ddcf68$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $6fc24e8e48ddcf68$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $6fc24e8e48ddcf68$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $6fc24e8e48ddcf68$export$93b21159ad85c843,
            $6fc24e8e48ddcf68$export$93b21159ad85c843 + "--" + options.type,
            $6fc24e8e48ddcf68$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $6fc24e8e48ddcf68$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $6fc24e8e48ddcf68$export$93b21159ad85c843 + "--nav",
            $6fc24e8e48ddcf68$export$72d36ecf3758cb4b,
            !this.config.hidden && $6fc24e8e48ddcf68$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $6fc24e8e48ddcf68$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $6fc24e8e48ddcf68$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $6fc24e8e48ddcf68$var$forOwn(styles, function(value, key) {
            style += " " + $6fc24e8e48ddcf68$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$6fc24e8e48ddcf68$var$push(slides, slides);
        $6fc24e8e48ddcf68$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $6fc24e8e48ddcf68$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $6fc24e8e48ddcf68$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $6fc24e8e48ddcf68$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $6fc24e8e48ddcf68$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $6fc24e8e48ddcf68$var$SIZE + " " + $6fc24e8e48ddcf68$var$SIZE + "\" width=\"" + $6fc24e8e48ddcf68$var$SIZE + "\" height=\"" + $6fc24e8e48ddcf68$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $6fc24e8e48ddcf68$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/**
* jquery-match-height master by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/ 
(function($, window1, document1) {
    /*
    *  internal
    */ var _previousResizeWidth = -1, _updateTimeout = -1;
    /*
    *  _parse
    *  value parse utility function
    */ var _parse = function _parse(value) {
        // parse value and convert NaN to 0
        return parseFloat(value) || 0;
    };
    /*
    *  _rows
    *  utility function returns array of jQuery selections representing each row
    *  (as displayed after float wrapping applied by browser)
    */ var _rows = function _rows(elements) {
        var tolerance = 1, $elements = $(elements), lastTop = null, rows = [];
        // group elements by their top position
        $elements.each(function() {
            var $that = $(this), top = $that.offset().top - _parse($that.css('margin-top')), lastRow = rows.length > 0 ? rows[rows.length - 1] : null;
            if (lastRow === null) // first item on the row, so just push it
            rows.push($that);
            else // if the row top is the same, add to the row group
            if (Math.floor(Math.abs(lastTop - top)) <= tolerance) rows[rows.length - 1] = lastRow.add($that);
            else // otherwise start a new row group
            rows.push($that);
            // keep track of the last row top
            lastTop = top;
        });
        return rows;
    };
    /*
    *  _parseOptions
    *  handle plugin options
    */ var _parseOptions = function _parseOptions(options) {
        var opts = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };
        if ((typeof options === "undefined" ? "undefined" : (0, $cf9fea04db19f9e8$export$71511d61b312f219)(options)) === 'object') return $.extend(opts, options);
        if (typeof options === 'boolean') opts.byRow = options;
        else if (options === 'remove') opts.remove = true;
        return opts;
    };
    /*
    *  matchHeight
    *  plugin definition
    */ var matchHeight = $.fn.matchHeight = function matchHeight1(options) {
        var opts = _parseOptions(options);
        // handle remove
        if (opts.remove) {
            var that = this;
            // remove fixed height from all selected elements
            this.css(opts.property, '');
            // remove selected elements from all groups
            $.each(matchHeight._groups, function(key, group) {
                group.elements = group.elements.not(that);
            });
            // TODO: cleanup empty groups
            return this;
        }
        if (this.length <= 1 && !opts.target) return this;
        // keep track of this group so we can re-apply later on load and resize events
        matchHeight._groups.push({
            elements: this,
            options: opts
        });
        // match each element's height to the tallest element in the selection
        matchHeight._apply(this, opts);
        return this;
    };
    /*
    *  plugin global options
    */ matchHeight.version = 'master';
    matchHeight._groups = [];
    matchHeight._throttle = 80;
    matchHeight._maintainScroll = false;
    matchHeight._beforeUpdate = null;
    matchHeight._afterUpdate = null;
    matchHeight._rows = _rows;
    matchHeight._parse = _parse;
    matchHeight._parseOptions = _parseOptions;
    /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */ matchHeight._apply = function(elements, options) {
        var opts = _parseOptions(options), $elements = $(elements), rows = [
            $elements
        ];
        // take note of scroll position
        var scrollTop = $(window1).scrollTop(), htmlHeight = $('html').outerHeight(true);
        // get hidden parents
        var $hiddenParents = $elements.parents().filter(':hidden');
        // cache the original inline style
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.data('style-cache', $that.attr('style'));
        });
        // temporarily must force hidden parents visible
        $hiddenParents.css('display', 'block');
        // get rows if using byRow, otherwise assume one row
        if (opts.byRow && !opts.target) {
            // must first force an arbitrary equal height so floating elements break evenly
            $elements.each(function() {
                var $that = $(this), display = $that.css('display');
                // temporarily force a usable display value
                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') display = 'block';
                // cache the original inline style
                $that.data('style-cache', $that.attr('style'));
                $that.css({
                    'display': display,
                    'padding-top': '0',
                    'padding-bottom': '0',
                    'margin-top': '0',
                    'margin-bottom': '0',
                    'border-top-width': '0',
                    'border-bottom-width': '0',
                    'height': '100px',
                    'overflow': 'hidden'
                });
            });
            // get the array of rows (based on element top position)
            rows = _rows($elements);
            // revert original inline styles
            $elements.each(function() {
                var $that = $(this);
                $that.attr('style', $that.data('style-cache') || '');
            });
        }
        $.each(rows, function(key, row) {
            var $row = $(row), targetHeight = 0;
            if (!opts.target) {
                // skip apply to rows with only one item
                if (opts.byRow && $row.length <= 1) {
                    $row.css(opts.property, '');
                    return;
                }
                // iterate the row and find the max height
                $row.each(function() {
                    var $that = $(this), style = $that.attr('style'), display = $that.css('display');
                    // temporarily force a usable display value
                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') display = 'block';
                    // ensure we get the correct actual height (and not a previously set height value)
                    var css = {
                        'display': display
                    };
                    css[opts.property] = '';
                    $that.css(css);
                    // find the max height (including padding, but not margin)
                    if ($that.outerHeight(false) > targetHeight) targetHeight = $that.outerHeight(false);
                    // revert styles
                    if (style) $that.attr('style', style);
                    else $that.css('display', '');
                });
            } else // if target set, use the height of the target element
            targetHeight = opts.target.outerHeight(false);
            // iterate the row and apply the height to all elements
            $row.each(function() {
                var $that = $(this), verticalPadding = 0;
                // don't apply to a target
                if (opts.target && $that.is(opts.target)) return;
                // handle padding and border correctly (required when not using border-box)
                if ($that.css('box-sizing') !== 'border-box') {
                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
                }
                // set the height (accounting for padding and border)
                $that.css(opts.property, targetHeight - verticalPadding + 'px');
            });
        });
        // revert hidden parents
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.attr('style', $that.data('style-cache') || null);
        });
        // restore scroll position if enabled
        if (matchHeight._maintainScroll) $(window1).scrollTop(scrollTop / htmlHeight * $('html').outerHeight(true));
        return this;
    };
    /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */ matchHeight._applyDataApi = function() {
        var groups = {};
        // generate groups by their groupId set by elements using data-match-height
        $('[data-match-height], [data-mh]').each(function() {
            var $this = $(this), groupId = $this.attr('data-mh') || $this.attr('data-match-height');
            if (groupId in groups) groups[groupId] = groups[groupId].add($this);
            else groups[groupId] = $this;
        });
        // apply matchHeight to each group
        $.each(groups, function() {
            this.matchHeight(true);
        });
    };
    /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */ var _update = function _update(event) {
        if (matchHeight._beforeUpdate) matchHeight._beforeUpdate(event, matchHeight._groups);
        $.each(matchHeight._groups, function() {
            matchHeight._apply(this.elements, this.options);
        });
        if (matchHeight._afterUpdate) matchHeight._afterUpdate(event, matchHeight._groups);
    };
    matchHeight._update = function(throttle, event) {
        // prevent update if fired from a resize event
        // where the viewport width hasn't actually changed
        // fixes an event looping bug in IE8
        if (event && event.type === 'resize') {
            var windowWidth = $(window1).width();
            if (windowWidth === _previousResizeWidth) return;
            _previousResizeWidth = windowWidth;
        }
        // throttle updates
        if (!throttle) _update(event);
        else if (_updateTimeout === -1) _updateTimeout = setTimeout(function() {
            _update(event);
            _updateTimeout = -1;
        }, matchHeight._throttle);
    };
    /*
    *  bind events
    */ // apply on DOM ready event
    $(matchHeight._applyDataApi);
    // update heights on load and resize events
    $(window1).bind('load', function(event) {
        matchHeight._update(false, event);
    });
    // throttled update heights on resize events
    $(window1).bind('resize orientationchange', function(event) {
        matchHeight._update(true, event);
    });
})(jQuery, window, document);


var $c5451969b5b9c323$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if ($c5451969b5b9c323$exports) $c5451969b5b9c323$exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function init() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function hasClass(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function addClass(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function removeClass(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function addRemoveLoadEvents1(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function updatePolyfill(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function getCSS(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function getWidth(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function run() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function rafBatch(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function rAFIt(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function throttle(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function run() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function idleCallback() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function debounce(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function run() {
            timeout = null;
            func();
        };
        var later = function later1() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function resetPreloading(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function isVisible(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function isNestedVisible(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function checkElements() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function switchLoadingClass(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function changeIframeSrc(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function handleSources(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function unveilElement(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function altLoadmodeScrollListner() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function onload1() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function _() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function getSizeElement(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function updateElementsSizes() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function _() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function init1() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});



"use strict";
// County filtering functionality
document.addEventListener("DOMContentLoaded", function() {
    var container = document.querySelector(".js-select-office-by-county");
    if (!container) return;
    var countyRadios = container.querySelectorAll('input[name="selection"]');
    var officeSections = container.querySelectorAll("[data-county]");
    var officesSection = container.querySelector("#offices-by-county");
    if (!countyRadios.length || !officesSection) return;
    function filterOfficesByCounty(selectedCounty) {
        officeSections.forEach(function(section) {
            var county = section.getAttribute("data-county");
            if (county === selectedCounty) section.style.display = "";
            else section.style.display = "none";
        });
    }
    // Add event listeners to radio buttons
    countyRadios.forEach(function(radio) {
        radio.addEventListener("change", function() {
            if (this.checked) filterOfficesByCounty(this.value);
        });
    });
    // Initialize: hide all offices by default
    officeSections.forEach(function(section) {
        section.style.display = "none";
    });
});


/*import 'jquery';
*/ // Make Vue available globally (as suggested in previous solution)
//import 'googlemaps';
//import 'GMaps';
//import "sticky-kit/dist/sticky-kit.js";
document.addEventListener('DOMContentLoaded', function() {
    // Initialize Bootstrap 5 dropdowns
    var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
    var dropdownList = dropdownElementList.map(function(dropdownToggleEl) {
        return new $5f9c41b37c3854cb$export$931cbfb6bfb85fc(dropdownToggleEl, {
            // Optional: prevent auto-close when clicking inside dropdown
            autoClose: 'outside'
        });
    });
    // Optional: Add hover functionality for desktop
    var mediaQuery = window.matchMedia('(min-width: 768px)');
    if (mediaQuery.matches) document.querySelectorAll('.dropdown').forEach(function(dropdown) {
        dropdown.addEventListener('mouseenter', function() {
            var dropdownToggle = this.querySelector('.dropdown-toggle');
            var dropdownInstance = $5f9c41b37c3854cb$export$931cbfb6bfb85fc.getInstance(dropdownToggle);
            if (dropdownInstance) dropdownInstance.show();
        });
        dropdown.addEventListener('mouseleave', function() {
            var dropdownToggle = this.querySelector('.dropdown-toggle');
            var dropdownInstance = $5f9c41b37c3854cb$export$931cbfb6bfb85fc.getInstance(dropdownToggle);
            if (dropdownInstance) dropdownInstance.hide();
        });
    });
    // Handle mobile menu toggle
    var menuToggle = document.querySelector('.header-nav__toggle');
    var navigation = document.querySelector('.header-nav__navigation');
    if (menuToggle && navigation) menuToggle.addEventListener('click', function() {
        navigation.classList.toggle('is-visible');
    });
});
document.addEventListener("lazybeforeunveil", function(e) {
    var bg = e.target.getAttribute("data-bg");
    if (bg) e.target.style.backgroundImage = "url(" + bg + ")";
});
var $e6ac0cb05febf478$var$loaded = false;
$(document).ready(function() {
    var whatOffice = 0;
    $(".js-toggle-search").on("click", function() {
        $(".js-search-bar").toggleClass("is-visible");
        $(".js-header-nav").toggleClass("has-search-visible");
        if ($(".js-search-bar").hasClass("is-visible")) $(".js-search-form > input").focus();
        else $(".js-search-form").blur();
    });
    $(".js-toggle-nav").on("click", function(e) {
        e.preventDefault();
        $(".js-navigation").toggleClass("is-visible");
        if ($(".js-navigation").hasClass("is-visible")) {
            $(".js-navigation > ul").focus(); // set focus.
            $("body").addClass("is-locked"); //
        } else {
            $(".header-nav__toggle.js-toggle-nav").focus();
            $("body").removeClass("is-locked");
        }
    });
    $(".js-file").on("change", function(e) {
        var file = $(this)[0].files[0];
        var t = $(this);
        if (file) {
            //$(this).find('span').html('hei');
            //t.find('.has-files').html('test');
            t.next(".input__label").find("span.has-files").text(file.name);
            t.next(".input__label").find("span.no-files").hide();
        } else {
            //$(this).find('span').html('hei');
            t.next(".input__label").find("span.has-files").text("");
            t.next(".input__label").find("span.no-files").show();
        }
    });
    $(".js-counter").each(function() {
        var $this = $(this), countTo = $this.attr("data-count"), countSpeed = $this.attr("data-count-speed");
        $({
            countNum: $this.text()
        }).animate({
            countNum: countTo
        }, {
            duration: 0,
            easing: "linear",
            step: function step() {
                $this.text(Math.floor(this.countNum));
            },
            complete: function complete() {
                $this.text(this.countNum);
            //alert('finished');
            }
        });
    });
    $(function() {
        $(".js-equal-height").matchHeight();
    });
    // Select all links with hashes
    $('a[href*="#"]')// Remove links that don't actually link to anything
    .not('[href="#"]').not('[href="#0"]').not(".collapsable-element").click(function(event) {
        // On-page links
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) // Checking if the target was focused
                    return false;
                    else {
                        $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    }
                });
            }
        }
    });
    var map = "";
    function initMap() {
        //var data = window.trafficData;
        var maps = $(".js-maps");
        var zoomLevel = $(".js-maps").data("zoom-level");
        var isSingle = $(".js-maps").data("type-single");
        // set default zoom to be used if type-single != true.
        var lat = 64.5602358, lng = 12.476;
        if (isSingle === true) {
            var target = $(".js-maps .js-office-marker");
            lat = target.data("map-lat");
            lng = target.data("map-lng");
        //console.log(lat + lng);
        }
        // center map
        // build map
        var mapsView = {
            div: "#map",
            lat: lat,
            lng: lng,
            zoom: zoomLevel,
            markerClusterer: function markerClusterer(map) {
                var options = {
                    gridSize: 20,
                    styles: [
                        {
                            textColor: "white",
                            url: "/img/clustermarker.png",
                            height: 30,
                            width: 30
                        }
                    ]
                };
                return new MarkerClusterer(map, [], options);
            },
            styles: [
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e9e9e9"
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5"
                        },
                        {
                            lightness: 20
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#ffffff"
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#ffffff"
                        },
                        {
                            lightness: 29
                        },
                        {
                            weight: 0.2
                        }
                    ]
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff"
                        },
                        {
                            lightness: 18
                        }
                    ]
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff"
                        },
                        {
                            lightness: 16
                        }
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5"
                        },
                        {
                            lightness: 21
                        }
                    ]
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dedede"
                        },
                        {
                            lightness: 21
                        }
                    ]
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            color: "#ffffff"
                        },
                        {
                            lightness: 16
                        }
                    ]
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            saturation: 36
                        },
                        {
                            color: "#333333"
                        },
                        {
                            lightness: 40
                        }
                    ]
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f2f2f2"
                        },
                        {
                            lightness: 19
                        }
                    ]
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#fefefe"
                        },
                        {
                            lightness: 20
                        }
                    ]
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#fefefe"
                        },
                        {
                            lightness: 17
                        },
                        {
                            weight: 1.2
                        }
                    ]
                }
            ]
        };
        map = new GMaps(mapsView);
        var marker = $(".js-office-marker"); // all markers.
        var markers = [];
        $.each(marker, function() {
            markers += marker;
        });
        $.each(marker, function(i, item) {
            var icon = {
                //scaledSize: new google.maps.Size(25, 16), // scaled size
                origin: new google.maps.Point(0, 0),
                // origin
                anchor: new google.maps.Point(0, 0) // anchor,
            };
            var t = $(this);
            map.addMarker({
                lat: t.data("map-lat"),
                lng: t.data("map-lng"),
                title: t.data("map-title"),
                icon: "/img/pin.png",
                // icon: icon,
                click: function click(e) {
                    // center this
                    map.map.panTo(e.position);
                //map.setZoom(17);
                },
                infoWindow: {
                    content: "<strong>" + t.data("map-title") + "</strong><br>" + t.data("map-address") + '<br><a href="' + t.data("map-link") + '">Se kontorets nettside</a>'
                }
            });
        });
    }
    // $('#officeselect').on('change', function(e) {
    //     //var target = $(this).data('target');
    //     //target = 0;
    //     var target = $('#officeselect option:selected').val();
    //     e.preventDefault();
    //     map.hideInfoWindows(); // hide all then open
    //     if(loaded){
    //         map.setZoom(17);
    //         map.panTo(map.markers[target].position);
    //     }
    //    (map.markers[target].infoWindow).open(map.map,map.markers[target]);
    // });
    function pythagorasEquirectangular(lat1, lon1, lat2, lon2) {
        lat1 = deg2Rad(lat1);
        lat2 = deg2Rad(lat2);
        lon1 = deg2Rad(lon1);
        lon2 = deg2Rad(lon2);
        var R = 6371;
        var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
        var y = lat2 - lat1;
        var d = Math.sqrt(x * x + y * y) * R;
        return d;
    }
    function deg2Rad(deg) {
        return deg * Math.PI / 180;
    }
    function nearestOffice(latitude, longitude) {
        var locations = [];
        var closest;
        $(".js-maps .js-office-marker").each(function() {
            if ($(this)[0].hasAttribute("data-map-lng")) locations.push([
                $(this).attr("data-map-lat"),
                $(this).attr("data-map-lng")
            ]);
        });
        var mindiff = 99999;
        for(var i = 0; i < locations.length; i++){
            var diff = pythagorasEquirectangular(latitude, longitude, locations[i][0], locations[i][1]);
            if (diff < mindiff) {
                closest = i;
                mindiff = diff;
            //console.log(closest)
            }
        }
        $(".js-maps").data("office", closest);
        setOffice(closest);
    }
    function setOffice(closest) {
        $(".js-maps").data("office", closest);
        $("#officeselect").val(closest).change().trigger("click");
    }
    var checkMap = $(".js-maps");
    if (checkMap.length >= 1) {
        initMap();
        if (navigator.geolocation) jQuery.post("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAf1Ek03p8FiQL6lMKqokpna2F3VJ-jSfY", function(success) {
            if ($("#officeselect").length) nearestOffice(success.location.lat, success.location.lng);
        }).fail(function(err) {
            setOffice(0);
            console.log("error for location");
        });
        else setOffice(0);
    }
});
function $e6ac0cb05febf478$var$handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("user-is-tabbing");
        window.removeEventListener("keydown", $e6ac0cb05febf478$var$handleFirstTab);
        window.addEventListener("mousedown", $e6ac0cb05febf478$var$handleMouseDownOnce);
    }
}
function $e6ac0cb05febf478$var$handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");
    window.removeEventListener("mousedown", $e6ac0cb05febf478$var$handleMouseDownOnce);
    window.addEventListener("keydown", $e6ac0cb05febf478$var$handleFirstTab);
}
window.addEventListener("keydown", $e6ac0cb05febf478$var$handleFirstTab);
$(window).scroll(function() {
    if ($(window).scrollTop() >= 300) $(".js-header-nav").addClass("is-stuck");
    else $(".js-header-nav").removeClass("is-stuck");
});
function $e6ac0cb05febf478$var$toggleMarker(selected) {
    var target = selected;
}
//var offices = window.offices;
/*Vue.component("single-office", {
  template:
    '<div class="offices__office"><h3 class="h4">{{data.name}}</h3><p>{{data.adress}}</p><p  v-if="data.email.length > 2"><strong>Epost:</strong> <span v-html="this.email(data.email)"></span></p><p v-if="data.phone.length > 2"><strong>Telefon:</strong> <span v-html="this.phone(data.phone)"></span></p><p v-if="data.link.length > 2"><span v-html="this.link(data.link)"></span></p></div>',
  props: ["data"],
  methods: {
    email: function (email) {
      let emailMarkup = '<a href="mailto:' + email + '">' + email + "</a>";
      return emailMarkup;
    },
    link: function (link) {
      let linkMarkup =
        '<a href="' +
        link +
        '" class="btn btn--red btn--medium">Se kontorets nettside</a>';
      return linkMarkup;
    },
    phone: function (phone) {
      let phoneNoSpaces = phone.replace(/\s/g, "");
      let phoneMarkup = '<a href="tel:' + phoneNoSpaces + '">' + phone + "</a>";
      return phoneMarkup;
    },
  },
});*/ /*Vue.component('single-office', {
  props: ['data'],
  template: `
       <div class="office-details">
         <h3>{{ data.name }}</h3>
         <p>{{ data.adress }}</p>
         <p v-if="data.addressPostal">{{ data.addressPostal }}</p>
         <p v-if="data.email">Email: {{ data.email }}</p>
         <p v-if="data.phone">Telefon: {{ data.phone }}</p>
         <a :href="data.link" class="btn btn-primary">Besøk kontor</a>
       </div>
     `
});*/ /*document.addEventListener('DOMContentLoaded', function() {
  const office = document.querySelector("#office");
  if (office !== null) {
    // Get offices data from wherever it's available
    const offices = window.offices || []; // Use global variable if available

    var app = new Vue({
      el: "#office",
      methods: {
        myFilter(option, label, search) {
          const temp = search.toLowerCase();
          return (
              option.adress.toLowerCase().includes(temp) ||
              option.county.toLowerCase().includes(temp) ||
              option.name.toLowerCase().includes(temp) ||
              option.addressPostal.toLowerCase().includes(temp)
          );
        },
        setSelected(selected) {
          if (selected) {
            this.selected = selected;
            this.current = selected.name;
          }
        },
      },
      mounted() {
        this.sortedOffices = this.offices.sort((a, b) =>
            a.name.localeCompare(b.name)
        );
      },
      data: {
        selected: null,
        current: null,
        offices: offices,
        sortedOffices: null,
      },
    });
  }
});*/ // SPLIDE SLIDER
function $e6ac0cb05febf478$var$initSplideHeaderSliders() {
    var sliders = document.querySelectorAll(".splide-header");
    for(var i = 0; i < sliders.length; i++){
        new $6fc24e8e48ddcf68$export$24494c7438c070bf(sliders[i], {
            type: "loop",
            autoplay: true,
            interval: 1000,
            perPage: 2,
            updateOnMove: true,
            pagination: false,
            gap: 20,
            rewind: true // Only needed for fade if we want it to loop
        }).mount();
        sliders[i].classList.add("splide-header-" + i);
    }
}
document.addEventListener("DOMContentLoaded", function() {
    $e6ac0cb05febf478$var$initSplideHeaderSliders();
});

})();
//# sourceMappingURL=scripts.js.map
